import { AfterViewChecked, Component, ElementRef, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { ChatbotService } from '../../../services/chatbot-services/chatbot.service';
import { FormBuilder } from '@angular/forms';
import { environment } from "src/environments/environment";
import { PrivilegesService } from "../../../services/privileges-service/privileges.service"
import { SelectedModuleService } from '../../../services/selected-module-service/selected-module.service';
import nlp from 'compromise';
import * as XLSX from 'xlsx';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import moduleDetails from '../../../config/module_info.json';
import config from '../../../config/config.json';
import { AutoResizeTextareaDirective } from '../../../directives/textarea/auto-resize-textarea.directive';
import { Subscription } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { SharedService } from '../../../services/shared-service/shared.service';
import { ConfigurationService } from '../../../services/configuration/configuration.service';
import { LoggerService } from '../../../services/logger-services/logger.service';
import { DataSetVdb, ModuleInfo } from '../../models/chatbot.models';

@Component({
  selector: 'app-chatbot-old',
  templateUrl: './chatbot-old.component.html',
  styleUrls: ['./chatbot-old.component.css']
})

export class ChatbotOldComponent implements OnInit, AfterViewChecked {
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  @ViewChild(AutoResizeTextareaDirective) autoResizeDirective!: AutoResizeTextareaDirective;
  IsFirstTime: any = true;
  IsNewChat: any = false;
  isUserHaveAccess: any | undefined;
  txtChat: any;
  questiontxt: string = "";
  moduleName: string = "";
  userFName: any;
  data: any;
  answer: any;
  ChatQueriesList: any = [];
  ChatQueriesObj: any = {};
  SessionChatHistory: any = []
  chat: any;
  reqOrRes: any;
  isStatic: boolean | undefined;
  loginId: any;
  SelSessionID: any;
  SelHisQuestionID: any;
  chatSessionList: any = [];
  sessionIdClickArray: string[] = [];
  sessionIdArray: string[] = [];
  exportlist: string[] = [];
  DomainID: any;
  UserID: any;
  currentSessionId: any;
  isNewChatSession: boolean | undefined;
  defaultChat: boolean | undefined;
  typedText: any;
  showEdit: boolean | undefined;
  editIndex: any;
  updateQuestion: any;
  editText: any;
  followUpQuestions: any;
  followUpQuestionsShow: boolean | undefined;
  ChatbotAccessText: string = "";
  prompt: string = 'default';
  selectedItemIndex: number | null = null;
  loaderShow: boolean = false;
  DisplayName: string = "";
  popularQuestions: any;
  chatBotName: string = "";
  note: boolean = false;
  popularQuestionsShow: boolean | undefined;
  userDataPrivileges: any = [];
  Markets: any = [];
  configdata: any;
  isResponseScroll: boolean = true;
  isChecked: boolean = false;
  InsightViewURL: string = "/regulations?modulePath=/Insights/view-regulation?tab=true&insid=";
  allUserPrivileges: any = null;
  isDocChat: boolean = false;
  linkUrl: string = "";
  DisLikeMessage: string = "";
  FeedbackOptions: any = [];
  AdditionalComments: string = "";
  FeedbackCBDict: any = {};
  DummyArray = [];
  jsonArray: string = "";
  IsLikeSelected: boolean = false;
  SubmitFeedback: boolean = false;
  ErrorMsg: boolean = false;
  count: number = 0;
  errorMsg: string = "";
  tenantID: any;
  streamResponseURL?: string;
  subModuleNames: any;
  xApiKey?: string;
  docChatApiUrl?: string;
  ViewFileUrl?: string;
  private hubConnectionBuilder!: HubConnection;
  isOptionsEnable: boolean = true;
  vectorDbDatasets: DataSetVdb[] = [];
  Privileges: any;
  selectedVectorDbDataset: DataSetVdb | undefined;
  IsModuleAccessible = false;
  selected_module_name = "";
  IsResponseStreaming: boolean = false;
  IsLoader: boolean = false;
  displayStopStreaming: boolean = false;
  ShowChatHistory: boolean = false;
  ConversationHistoryCount: number = 0;
  ShowRegulationMarketsWindow: boolean = false;
  RegulationId: string = "";
  RegulationMarkets: string = "";
  RegulationTitle: string = "";
  DeleteSuccessMessage: boolean = false;
  EditSuccessMessage: boolean = false;
  ChatTitle: string = "";
  URFModuleId: number = 0;
  isDomainManagementEnabled: boolean = false;
  IsCustomErrorMessageVisible: boolean = false;
  CustomErrorMessageText: string = "";
  isProcessing: boolean = false;
  vectorDbDatasetList: any = [];
  allDomainNamesList: string[] = [];
  currentSelectedDomain: string = '';
  private readonly ChatbotOldComponentError = (error: any)=>
    `[ChatbotOldComponent] ${JSON.stringify(error)}`;

  // Cookie utility functions
  private setCookie(name: string, value: string, days: number = 365): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    const expiresString = expires.toUTCString();
    document.cookie = `${name}=${value}; expires=${expiresString}; path=/`;
  }

  private getCookieValue(cookieName: string): string {
    try{
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');

    for (const cookie of cookies) {
      let trimmedCookie = cookie.trim();
      if (trimmedCookie.startsWith(name)) {
        return trimmedCookie.substring(name.length);
      }
    }
    return '';
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "getCookieValue")
    return '';
  }
  }

  // Get user-specific domain preference key
  private getUserDomainPreferenceKey(): string {
    return `FREYA_USER_DOMAIN_${this.UserID}_${this.tenantID}`;
  }

  // Get user's last selected domain from localStorage
  private getUserDomainPreference(): string {
    const key = this.getUserDomainPreferenceKey();
    return localStorage.getItem(key) || '';
  }

  // Save user's domain preference to localStorage
  private saveUserDomainPreference(domain: string): void {
    const key = this.getUserDomainPreferenceKey();
    localStorage.setItem(key, domain);
  }

  // Get the effective domain based on domain management settings
  private getEffectiveDomain(): string {
    try{
    if (this.isDomainManagementEnabled) {
      // When domain management is enabled, be completely independent of parent app
      const userPreference = this.getUserDomainPreference();
      
      // 1. Check user's last preference (if valid for current user/module)
      if (userPreference && this.allDomainNamesList.includes(userPreference)) {
        return userPreference;
      }
      
      // 2. Use first available domain from accessible domains
      if (this.allDomainNamesList.length > 0) {
        const firstDomain = this.allDomainNamesList[0];
        this.saveUserDomainPreference(firstDomain);
        return firstDomain;
      }
    } else {
      // When domain management is disabled, use parent app cookie as-is
      const parentDomain = this.getCookieValue('DOMAIN');
      if (parentDomain && this.allDomainNamesList.includes(parentDomain)) {
        return parentDomain;
      }
    }
    
    // Final fallback
    return this.allDomainNamesList.length > 0 ? this.allDomainNamesList[0] : '';
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "getEffectiveDomain")
    return '';
  }
  }

  // Update domain preference
  private updateDomainAndSync(domain: string): void {
    if (this.isDomainManagementEnabled) {
      // update localStorage
      this.saveUserDomainPreference(domain);
    }
  }

  // Handle domain selection with localStorage update and reload
  onDomainSelected(selectedDomain: string): void {
    try{
    if (!this.isDomainManagementEnabled) {
      return;
    }

    // Get current domain from localStorage
    const currentDomain = this.getUserDomainPreference();
    
    // Only proceed if the selected domain is different from current
    if (selectedDomain !== currentDomain) {      
      // Update domain
      this.updateDomainAndSync(selectedDomain);
      
      // Update current selected domain
      this.currentSelectedDomain = selectedDomain;
      
      // Reload the page to reflect the new domain
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "onDomainSelected")
    return;
  }
  }

  // Helper methods for metadata conversion between array and object formats
  
  /**
   * Converts metadata array to direct object format for saving to API
   * @param metadataArray - Array format metadata
   * @returns Direct object format metadata for API storage (no sortedMetadata wrapper)
   */
  private convertMetadataForSaving(metadataArray: any[]): any {
    try{
    if (!Array.isArray(metadataArray) || metadataArray.length === 0) {
      this.loggerService.logError(this.ChatbotOldComponentError("Metadata array is not an array or is empty"), "convertMetadataForSaving")
      return {};
    }
    
    // Get current module name to determine format
    const currentModuleName = this.configdata?.DisplayName?.replace(/^@/, '').toLowerCase() || '';
    const isNewFormatModule = currentModuleName === 'regulations' || currentModuleName === 'rtq';
    
    // If metadata array contains objects with sortedMetadata, extract the direct object
    if (metadataArray.length === 1 && metadataArray[0] && typeof metadataArray[0] === 'object') {
      const obj = metadataArray[0];
      
      // If it has sortedMetadata property, get the sortedMetadata
      if ('sortedMetadata' in obj && typeof obj.sortedMetadata === 'object') {
        const metadata = obj.sortedMetadata;
        
        // Convert to new format if needed for regulations/rtq modules
        if (isNewFormatModule) {
          const converted = this.convertToNewMetadataFormat(metadata, currentModuleName);
          return this.filterEmptyReferences(converted);
        }
        
        return this.filterEmptyReferences(metadata);
      }
      
      // If it's already in the direct format (has numeric keys), check if conversion needed
      const keys = Object.keys(obj);
      if (keys.some(key => !isNaN(Number(key))) || keys.some(key => obj[key]?.title || obj[key]?.ins_id)) {
        // Convert to new format if needed for regulations/rtq modules
        if (isNewFormatModule) {
          const converted = this.convertToNewMetadataFormat(obj, currentModuleName);
          return this.filterEmptyReferences(converted);
        }
        
        return this.filterEmptyReferences(obj);
      }
    }
    
    // If it's a direct array of insight objects, convert to numbered object
    const result: any = {};
    metadataArray.forEach((item, index) => {
      // Only add item if it's not an empty object or has meaningful content
      if (item && typeof item === 'object' && Object.keys(item).length > 0) {
        // Check if the item has any non-empty values
        const hasContent = Object.values(item).some(value => {
          if (value === null || value === undefined || value === '') {
            return false;
          }
          if (Array.isArray(value) && value.length === 0) {
            return false;
          }
          if (typeof value === 'object' && Object.keys(value).length === 0) {
            return false;
          }
          return true;
        });
        
        if (hasContent) {
          result[index + 1] = item;
        }
      }
    });
    
    // Convert to new format if needed for regulations/rtq modules
    if (isNewFormatModule) {
      const converted = this.convertToNewMetadataFormat(result, currentModuleName);
      return this.filterEmptyReferences(converted);
      
    }
    
    return this.filterEmptyReferences(result);
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "convertMetadataForSaving")
    return {};
  }
  }

  /**
   * Filters out empty reference objects and returns {} if no valid references exist
   * @param references - References object to filter
   * @returns Filtered references object or {} if no valid references
   */
  private filterEmptyReferences(references: any): any {
    try{
    if (!references || typeof references !== 'object') {
      this.loggerService.logError(this.ChatbotOldComponentError("References is not an object or is empty"), "filterEmptyReferences")
      return {};
    }

    const filteredReferences: any = {};
    
    Object.keys(references).forEach(key => {
      const value = references[key];
      
      // Skip if value is null, undefined, or empty object
      if (value === null || value === undefined) {
        return;
      }
      
      // If it's an object, check if it has meaningful content
      if (typeof value === 'object') {
        if (Object.keys(value).length === 0) {
          // Skip empty objects
          return;
        }
        
        // Check if the object has any non-empty values
        const hasContent = Object.values(value).some(v => {
          if (v === null || v === undefined || v === '') {
            return false;
          }
          if (Array.isArray(v) && v.length === 0) {
            return false;
          }
          if (typeof v === 'object' && Object.keys(v).length === 0) {
            return false;
          }
          return true;
        });
        
        if (hasContent) {
          filteredReferences[key] = value;
        }
      } else {
        // For non-object values, include if not empty string
        if (value !== '') {
          filteredReferences[key] = value;
        }
      }
    });

    return filteredReferences;
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "filterEmptyReferences")
    return {};
  }
  }

  /**
   * Converts old metadata format to new format for regulations and rtq modules
   * @param oldMetadata - Old format metadata with structure like { "1": { "ins_id": ..., "title": ..., etc }, "2": {...} }
   * @param moduleName - Current module name (regulations or rtq)
   * @returns New format metadata with structure like { "1": { "id": ..., "module_name": ..., "metadata": {...}, etc } }
   */
  private convertToNewMetadataFormat(oldMetadata: any, moduleName: string): any {
    try{
    if (!oldMetadata || typeof oldMetadata !== 'object') {
      this.loggerService.logError(this.ChatbotOldComponentError("Old metadata is not an object or is empty"), "convertToNewMetadataFormat")
      return {};
    }

    const newMetadata: any = {};
    
    Object.keys(oldMetadata).forEach(key => {
      const oldItem = oldMetadata[key];
      if (!oldItem || typeof oldItem !== 'object') {
        return;
      }

      // Skip empty metadata items (no meaningful content)
      const hasContent = oldItem.ins_id || oldItem.id || oldItem.rtq_id || oldItem.title || oldItem.query_title ||
                        (oldItem.countries && oldItem.countries.length > 0) ||
                        oldItem.authority || oldItem.attachment_name || oldItem.ref_url ||
                        oldItem.product_id || oldItem.product_name || oldItem.productName;
      
      if (!hasContent) {
        return;
      }

      // Create new format structure
      const newItem: any = {
        id: oldItem.ins_id || oldItem.rtq_id || oldItem.id || '',
        module_name: moduleName,
        metadata: {},
        relevance_score: 'HIGH', // Default value as shown in example
        explanation: oldItem.title || oldItem.query_title || '' // Use title as explanation
      };

      // Map old fields to new metadata structure
      if (moduleName === 'regulations') {
        newItem.metadata = {
          title: oldItem.title || '',
          countries: oldItem.countries || [],
          authority: oldItem.authority || '',
          encrypted_regulation_id: oldItem.encrypted_regulation_id || '',
          attachment_name: oldItem.attachment_name || '',
          ref_url: oldItem.ref_url || ''
        };
      } else if (moduleName === 'rtq') {
        // Handle countries: convert string back to array if needed
        let countriesArray = oldItem.countries || [];
        if (typeof oldItem.Country === 'string' && oldItem.Country) {
          countriesArray = oldItem.Country.split(',').map((c: string) => c.trim());
        }
        
        newItem.metadata = {
          query_title: oldItem.title || oldItem.query_title || '',
          countries: countriesArray,
          authority: oldItem.authority || '',
          product_id: oldItem.product_id || '',
          product_name: oldItem.productName || oldItem.product_name || '', // Handle both productName and product_name
          country_group: oldItem.country_group || ''
        };
      }

      // Preserve any additional fields that might be needed
      Object.keys(oldItem).forEach(field => {
        if (!['ins_id', 'id', 'rtq_id', 'title', 'query_title', 'countries', 'Country', 'authority', 
              'encrypted_regulation_id', 'attachment_name', 'ref_url', 
              'product_id', 'product_name', 'productName', 'country_group'].includes(field)) {
          if (!newItem.metadata[field]) {
            newItem.metadata[field] = oldItem[field];
          }
        }
      });

      newMetadata[key] = newItem;
    });

    return newMetadata;
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "convertToNewMetadataFormat")
    return {};
  }
  }

  /**
   * Converts metadata object to array format for display in templates
   * @param metadataObj - Object format metadata from API
   * @returns Array format metadata for template *ngFor with keys pipe
   */
  private convertMetadataForDisplay(metadataObj: any): any[] {
    try{
    if (!metadataObj) {
      this.loggerService.logError(this.ChatbotOldComponentError("Metadata object is not an object or is empty"), "convertMetadataForDisplay")
      return [];
    }
    
    // If it's already an array, return as is
    if (Array.isArray(metadataObj)) {
      return metadataObj;
    }
    
    // If it's an object with sortedMetadata property, return the sortedMetadata object wrapped in array
    // This allows the template to use: *ngFor="let data of array" then *ngFor="let insight of data| keys"
    if (metadataObj.sortedMetadata && typeof metadataObj.sortedMetadata === 'object') {
      // Check if sortedMetadata is empty
      if (Object.keys(metadataObj.sortedMetadata).length === 0) {
        return [];
      }
      return [metadataObj.sortedMetadata];
    }
    
    // If it's a plain object that looks like sortedMetadata (has numeric keys), check for new format conversion
    if (typeof metadataObj === 'object' && Object.keys(metadataObj).length > 0) {
      const keys = Object.keys(metadataObj);
      
      // Check if it looks like new format metadata (has keys with id, module_name, metadata structure)
      const hasNewFormat = keys.some(key => {
        const item = metadataObj[key];
        return item && typeof item === 'object' && 
               'id' in item && 'module_name' in item && 'metadata' in item;
      });
      
      if (hasNewFormat) {
        // Convert new format back to old format for display compatibility
        const convertedMetadata = this.convertNewFormatToOldForDisplay(metadataObj);
        // If conversion resulted in empty metadata, return empty array
        if (!convertedMetadata || Object.keys(convertedMetadata).length === 0) {
          return [];
        }
        return [convertedMetadata];
      }
      
      // Check if it looks like old format sortedMetadata (has numeric keys or insight-like structure)
      if (keys.some(key => !isNaN(Number(key))) || keys.some(key => metadataObj[key]?.title || metadataObj[key]?.ins_id)) {
        return [metadataObj];
      }
    }
    
    return [];
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "convertMetadataForDisplay")
    return [];
  }
  }

  /**
   * Converts new format metadata back to old format for display compatibility
   * @param newFormatMetadata - New format metadata from API
   * @returns Old format metadata for display
   */
  private convertNewFormatToOldForDisplay(newFormatMetadata: any): any {
    try{
    if (!newFormatMetadata || typeof newFormatMetadata !== 'object') {
      this.loggerService.logError(this.ChatbotOldComponentError("New format metadata is not an object or is empty"), "convertNewFormatToOldForDisplay")
      return {};
    }

    const oldFormatMetadata: any = {};
    
    Object.keys(newFormatMetadata).forEach(key => {
      const newItem = newFormatMetadata[key];
      if (!newItem || typeof newItem !== 'object') {
        return;
      }

      // Convert new format back to old format
      const oldItem: any = {
        ins_id: newItem.id || '',
        title: newItem.metadata?.title || newItem.metadata?.query_title || '',
        countries: newItem.metadata?.countries || [],
        authority: newItem.metadata?.authority || '',
        relevance_score: newItem.relevance_score || '',
        explanation: newItem.explanation || ''
      };

      // Add module-specific fields
      if (newItem.module_name === 'regulations') {
        oldItem.encrypted_regulation_id = newItem.metadata?.encrypted_regulation_id || '';
        oldItem.attachment_name = newItem.metadata?.attachment_name || '';
        oldItem.ref_url = newItem.metadata?.ref_url || '';
      } else if (newItem.module_name === 'rtq') {
        // RTQ-specific field mappings to match template expectations
        oldItem.rtq_id = newItem.id || ''; // RTQ template expects rtq_id
        oldItem.query_title = newItem.metadata?.query_title || '';
        oldItem.product_id = newItem.metadata?.product_id || '';
        oldItem.productName = newItem.metadata?.product_name || ''; // Template expects productName (camelCase)
        oldItem.country_group = newItem.metadata?.country_group || '';
        // Convert countries array to string for template compatibility
        oldItem.Country = Array.isArray(newItem.metadata?.countries) 
          ? newItem.metadata.countries.join(', ') 
          : (newItem.metadata?.countries || '');
      }

      // Preserve any additional metadata fields
      if (newItem.metadata && typeof newItem.metadata === 'object') {
        Object.keys(newItem.metadata).forEach(metaKey => {
          if (!oldItem.hasOwnProperty(metaKey)) {
            oldItem[metaKey] = newItem.metadata[metaKey];
          }
        });
      }

      oldFormatMetadata[key] = oldItem;
    });

    return oldFormatMetadata;
  }
  catch(error:any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "convertNewFormatToOldForDisplay")
    return {};
  }
  }

  /**
   * Getter method for templates to access metadata in array format
   * @param chatdata - Chat data object containing metadata
   * @returns Array format metadata for template use
   */
  getMetadataForDisplay(chatdata: any): any[] {
    if (!chatdata || !chatdata.metadata) {
      return [];
    }
    
    const result = this.convertMetadataForDisplay(chatdata.metadata);
    if (!Array.isArray(result)) {
      return [];
    
    }
    return result;
  }

  /**
   * Converts follow-up questions to string array format for saving to API
   * @param followUpQuestions - Internal format: [[{Question: "..."}, {Question: "..."}]]
   * @returns String array format for API: ["Question 1", "Question 2"]
   */
  private convertFollowUpQuestionsForSaving(followUpQuestions: any[]): string[] {
    if (!Array.isArray(followUpQuestions) || followUpQuestions.length === 0) {
      return [];
    }

    // Extract the first array (followUpQuestions[0])
    const questionsArray = followUpQuestions[0];
    if (!Array.isArray(questionsArray) || questionsArray.length === 0) {
      return [];
    }

    // Convert objects with Question property to string array
    return questionsArray.map((item: any) => {
      if (typeof item === 'string') {
        return item;
      }
      if (typeof item === 'object' && item.Question) {
        return item.Question;
      }
      return '';
    }).filter(q => q.trim() !== ''); // Remove empty strings
  }

  /**
   * Converts follow-up questions from API string array to internal object format
   * @param followUpQuestionsArray - API format: ["Question 1", "Question 2"]
   * @returns Internal format for templates: [[{Question: "Question 1"}, {Question: "Question 2"}]]
   */
  private convertFollowUpQuestionsForDisplay(followUpQuestionsArray: string[]): any[] {
    if (!Array.isArray(followUpQuestionsArray) || followUpQuestionsArray.length === 0) {
      return [];
    }

    // Convert string array to object array format
    const objectArray = followUpQuestionsArray.map((question: string) => ({
      Question: question
    }));

    // Return in the expected nested array format
    return [objectArray];
  }

  constructor(private formBuilder: FormBuilder,
    private chatbotService: ChatbotService,
    private elementRef: ElementRef,
    private privilegesService: PrivilegesService,
    private sharedService: SelectedModuleService,
    private renderer: Renderer2,
    private sharedScrollService: SharedService,
    private configService: ConfigurationService,
    private loggerService: LoggerService
  ) { }


  async ngOnInit(): Promise<void> {
    try{
    // Ensure all arrays are properly initialized to prevent NG0900 errors
    this.ChatQueriesList = Array.isArray(this.ChatQueriesList) ? this.ChatQueriesList : [];
    this.chatSessionList = Array.isArray(this.chatSessionList) ? this.chatSessionList : [];
    this.vectorDbDatasets = Array.isArray(this.vectorDbDatasets) ? this.vectorDbDatasets : [];
    this.followUpQuestions = Array.isArray(this.followUpQuestions) ? this.followUpQuestions : [];
    this.FeedbackOptions = Array.isArray(this.FeedbackOptions) ? this.FeedbackOptions : [];
    
    this.sharedScrollService.currentResponseScroll.subscribe(isScroll => this.isResponseScroll = isScroll);
    this.IsFirstTime = false;
    this.IsNewChat = false;
    this.defaultChat = false;
    this.isUserHaveAccess = false;
    this.UserID = environment.LoginUserID;
    this.moduleName = environment.DomainName;
    this.userFName = environment.LoginUserName;
    this.tenantID = environment.TenantId;
    this.Privileges = environment.Privileges;
    this.IsLikeSelected = false;
    this.SubmitFeedback = false;
    this.ErrorMsg = false;
    this.getConfigData();
    this.isDomainManagementEnabled = await this.configService.isDomainManagementEnabled();
    this.DisLikeMessage = this.configdata.DisLikeMessage;
    this.FeedbackOptions = Array.isArray(this.configdata.FeedbackOptions) ? this.configdata.FeedbackOptions : [];
    this.VerifyUserAccessToChatBot(this.UserID, this.DomainID);

    await this.GetDomainId();
    await this.GetURFModuleId();
    await this.fetchPrivilegesAndDatasets();

    // Update domains list if domain management is enabled
    if (this.isDomainManagementEnabled) {
      await this.updateDomainsList();
    }

    environment.GlobalInfo["DomainID"] = this.DomainID;
    environment.GlobalInfo["URFModuleId"] = this.URFModuleId;

    this.GetDomainName();
    this.Listdatasets();
    this.GetChatSessionsInfo(this.UserID, this.DomainID);
    this.userNameSimplify();
    this.scrollBottom();
    this.popularQuestionsShow = false;
    this.popularQuestions = [];
    this.chatBotName = environment.chatbotName;
    this.IsResponseStreaming = false;
    this.displayStopStreaming = false;
    this.IsLoader = false;
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "ngOnInit")
    return;
  }
  }

  // Ensure to also handle unsubscribing when the component is destroyed to prevent memory leaks
  ngOnDestroy(): void {
    this.stopStreaming(); // Stop the streaming if it's still active
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['moduleName']) {
      this.moduleName = environment.DomainName;
    }
    this.chatBotName = environment.chatbotName;
  }

  async fetchPrivilegesAndDatasets(): Promise<void> {
    try {
      this.showLoader();
      const result = await this.privilegesService.getPrivilegesList(this.UserID, this.URFModuleId, this.DomainID);
      this.vectorDbDatasets = Array.isArray(result.vectorDbDatasets) ? result.vectorDbDatasets : [];
      this.Privileges = result.cookiesArray;
      environment.GlobalInfo["vectorDbDatasets"] = result.vectorDbDatasets;
      environment.GlobalInfo["Privileges"] = result.cookiesArray;
      if (this.vectorDbDatasets && this.vectorDbDatasets.length > 0) {
        this.selectedVectorDbDataset = this.vectorDbDatasets.find(dataset => dataset.name.toLowerCase() === "regulations") || this.vectorDbDatasets[0];        
        // Trigger configuration update after selecting the dataset
        let sendVectorDbObj: any = {};
        sendVectorDbObj.type = 1;
        sendVectorDbObj.selectedVectorDbDataset = this.selectedVectorDbDataset;
        this.sharedService.changeSelectedValue(sendVectorDbObj);
      }
      this.hideLoader();
    } catch (error:any) {
      this.hideLoader();
      this.loggerService.logError(this.ChatbotOldComponentError(error), "fetchPrivilegesAndDatasets")
    }
  }

  /**
   * Updates the allDomainNamesList based on the currently selected vector database dataset
   * Always calls the API to get fresh domain mapping for the selected module
   */
  async updateDomainsList(): Promise<void> {
    try{
    if (!this.selectedVectorDbDataset?.name) {
      this.loggerService.logError(this.ChatbotOldComponentError("Selected vector database dataset is not an object or is empty"), "updateDomainsList")
      this.allDomainNamesList = [];
      return;
    }

    // Skip API call if domain management is not enabled
    if (!this.isDomainManagementEnabled) {
      this.loggerService.logError(this.ChatbotOldComponentError("Domain management is not enabled"), "updateDomainsList")
      return;
    }

    try {      
      // Always call API to get fresh domain mapping for the selected module
      const allAccessibleUserDomains = await firstValueFrom(
        this.chatbotService.getAllUserDomainsAPI(
          environment.TenantId, 
          environment.LoginUserID, 
          this.selectedVectorDbDataset.name
        )
      );
      
      // Get the updated mapping
      const result = this.chatbotService.mapDomainsToModules(allAccessibleUserDomains);
      
      // Update the domains list for the current selected dataset
      this.allDomainNamesList = result.moduleDomainsMap[this.selectedVectorDbDataset.name] || [];
            
      // Update current selected domain using effective domain logic
      this.currentSelectedDomain = this.getEffectiveDomain();
      
      // Show alert if no domains found for the module
      if (this.allDomainNamesList.length === 0) {
        this.showPopupMessage(
          "NoDomains",
          `No domains found for module '${this.selectedVectorDbDataset.name}'. Please contact your administrator or select a different module.`,
          `No accessible domains found for module: ${this.selectedVectorDbDataset.name}`
        );
      }
      
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotOldComponentError(error), "updateDomainsList")
      // Fall back to environment domain name if API call fails
      this.allDomainNamesList = [environment.DomainName];
      
      // Show error message for API failure
      this.showPopupMessage(
        "DomainsAPIError",
        `Failed to fetch domains for module '${this.selectedVectorDbDataset.name}'. Using default domain. Please check your connection or contact administrator.`,
        `API error while fetching domains for module: ${this.selectedVectorDbDataset.name} - ${error.message || error}`
      );
    }
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "updateDomainsList")
    return;
  }
  }

  Listdatasets() {
    for (let i = 0; i < this.vectorDbDatasets.length; i++) {
      this.vectorDbDatasetList.push(this.vectorDbDatasets[i].name);
    }
  }

  userNameSimplify() {

    let names: string[];
    if (this.userFName.includes("@")) {
      // If userFName is an email, split it at '@'
      let emailParts = this.userFName.split("@");
      // Further split the local part of the email at '.' or '_'
      names = emailParts[0].split(/[._]/);
    } else {
      names = this.userFName.split(" ");
    }

    // Ensure names only contain alphabets and make title case
    names = names.map((name) =>
      name.replace(/[^a-zA-Z]/g, "").replace(/\b\w/g, (l) => l.toUpperCase())
    );

    this.userFName = names.join(' ');

    if (names.length >= 2) {
      this.DisplayName = names[0].slice(0, 1) + names[1].slice(0, 1);
    } else {
      this.DisplayName = names[0].slice(0, 2);
    }
  }

  domainMapping(input: number | string): string[] | number {
    const domainMappings: { [key: number]: string[] } = {
      1: ["MPR"], // Medicinal Products
      2: ["COS"], // Cosmetics  
      3: ["MDV"], // Medical Devices
      4: ["CHP"], // Chemicals and Household Products
      5: ["FDS"], // Food and Food Supplements
    };
    
    if (typeof input === 'number') {
      // Get domain names by ID
      return domainMappings[input] || [];
    } else {
      // Get domain ID by name
      for (const [key, values] of Object.entries(domainMappings)) {
        if (values.includes(input)) {
          return parseInt(key);
        }
      }
      return 1; // Default to 1 if not found
    }
  }

  getDomainFullName(domainCode: string): string {
    const names: { [key: string]: string } = {
      'MPR': 'Medicinal Products',
      'COS': 'Cosmetics',
      'MDV': 'Medical Devices', 
      'CHP': 'Chemicals and Household Products',
      'FDS': 'Food and Food Supplements',
    };
    return names[domainCode.toUpperCase()] || domainCode;
  }

  onChatNameChange(item: any, currentValue: string, originalValue: string): void {
    item.isChatNameChanged = currentValue !== originalValue;
  }

  /* istanbul ignore next */
  getConfigData() {
    try{
    this.configdata = this.chatbotService.getConfigData();
    this.sharedService.currentSelectedValue.subscribe((value: any) => {
      this.selected_module_name = value?.selectedVectorDbDataset?.value || this.selectedVectorDbDataset?.value;

      if (this.selected_module_name) {
        const moduleInfo = (moduleDetails as any)[this.selected_module_name];
        if (moduleInfo) {
          this.configdata.domain_specific = moduleInfo?.domain_specific || false;
          this.configdata.chatbotName = moduleInfo?.chatbotName || config?.chatbotName;
          this.configdata.IntroDetails = moduleInfo.IntroDetails?.replace("{{userFName}}", this.userFName) || config?.IntroDetails.replace("{{userFName}}", this.userFName);;
          this.configdata.isPopularQuestionStart = moduleInfo?.isPopularQuestionStart ?? config?.isPopularQuestionStart;
          this.configdata.isPopularQuestionModuleWise = moduleInfo?.isPopularQuestionModuleWise ?? false;
          this.configdata.MarketsPayloadRequired = moduleInfo?.MarketsPayloadRequired ?? false;
          this.configdata.ReggieIntro = moduleInfo?.ReggieIntro ?? config?.ReggieIntro.replace("{{display_dataset_name}}", moduleInfo.DisplayName);
          this.configdata.ReggieDisclaimer = moduleInfo?.ReggieDisclaimer || config?.ReggieDisclaimer;
          this.configdata.ReggieTips = moduleInfo.ReggieTips || config?.ReggieTips;
          this.configdata.PopularQuestionContent = moduleInfo?.PopularQuestionContent || config?.PopularQuestionContent;
          this.configdata.subModuleNames = moduleInfo?.sub_module_names || [];
          this.configdata.isDocChat = moduleInfo?.IsDocChat ?? false;
          this.configdata.is_module_alias = moduleInfo?.is_module_alias ?? false;
          this.configdata.docChatApiUrl = moduleInfo?.RIApiUrl + moduleInfo?.DocChatApiSubUrl;
          this.configdata.ViewFileUrl = moduleInfo?.ViewFileUrl;
          this.configdata.DisplayName = moduleInfo?.DisplayName;
          this.configdata.StreamResponseSubURL = moduleInfo?.StreamResponseSubURL;
          this.configdata.userPrivileges = moduleInfo.USER_PRIVILEGES ? moduleInfo.USER_PRIVILEGES : [];
          this.configdata.RIApiUrl = moduleInfo?.RIApiUrl;
          this.configdata.DownloadApiToggle = moduleInfo?.DownloadApiToggle ?? false;
          this.configdata.DocChatUrl = moduleInfo?.DocChatUrl;
          this.configdata.DisplayName = moduleInfo?.DisplayName;
          this.configdata.RIUIUrl = moduleInfo?.RIUIUrl || '';
          this.configdata.FusionAppUIUrl = config?.FusionAppUIUrl;
          this.configdata.selected_module_name = this.selected_module_name;
          this.configdata.bucket_subfolder = moduleInfo?.bucket_subfolder || this.selected_module_name;
          this.isDocChat = this.configdata.isDocChat;
          this.configdata.api_module_name = moduleInfo?.api_module_name;
          this.configdata.default_tenant_id = this.tenantID;
          this.configdata.DisLikeMessage = moduleInfo?.DisLikeMessage || config.DisLikeMessage;
          this.configdata.FeedbackOptions = Array.isArray(moduleInfo?.FeedbackOptions) ? moduleInfo.FeedbackOptions : 
                                              (Array.isArray(config.FeedbackOptions) ? config.FeedbackOptions : []);
          this.configdata.default_tenant_id = moduleInfo?.default_tenant_id || this.tenantID
          this.configdata.Countries = this.configdata.MarketsPayloadRequired ? config?.Countries : [];
          this.configdata.schema_name = moduleInfo?.schema_name ?? "";
          this.configdata.RtqDownloadUrl = moduleInfo?.RtqDownloadUrl || (config as any)?.RtqDownloadUrl;          
          if (this.configdata.userPrivileges.length > 0) {
            try {
              const privilegesString = this.Privileges.replace(/^"(.+(?="$))"$/, '$1');
              const privilegesArray = JSON.parse(privilegesString);
              this.configdata.userPrivileges = this.configdata.userPrivileges.filter((privilege: { privilege_name: string }) => privilegesArray.includes(privilege.privilege_name));
              this.IsModuleAccessible = this.configdata.userPrivileges.some((privilege: { module_name: string }) => privilege.module_name === this.moduleName);
            } catch (error: any) {
              this.IsModuleAccessible = true;
              this.loggerService.logError(this.ChatbotOldComponentError(error), "getConfigData")
            }
          }
          else {
            this.IsModuleAccessible = true;
          }
          if (!this.IsModuleAccessible) {
            this.isUserHaveAccess = false;
            this.ChatbotAccessText = "You don't have access to '" + environment.chatbotName + "[" + this.moduleName + "]'. Please contact your system administrator to grant access.";
          }

          if (!this.configdata.is_module_alias && moduleInfo?.sub_module_names?.length > 0) {
            const module_Name = moduleInfo.sub_module_names.find(
              (subModule: any) => subModule.alias === this.moduleName
            );
            this.configdata.module_Name = module_Name?.name;
            this.configdata.actual_module_Name = module_Name?.alias;
          }

        }
      }
    });
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "getConfigData")
    return;
  }
  }

  showLoader() {
    this.loaderShow = true;
  }
  // Called when you want to hide the loader
  hideLoader() {
    this.loaderShow = false;
  }
  scrollBottom() {
    try {
      // Defensive array validation before DOM operations that trigger change detection
      if (!Array.isArray(this.ChatQueriesList)) this.ChatQueriesList = [];
      if (!Array.isArray(this.chatSessionList)) this.chatSessionList = [];
      if (!Array.isArray(this.followUpQuestions)) this.followUpQuestions = [];
      if (!Array.isArray(this.vectorDbDatasets)) this.vectorDbDatasets = [];
      if (!Array.isArray(this.FeedbackOptions)) this.FeedbackOptions = [];
      
      if (this.isResponseScroll && this.scrollContainer) {
        this.scrollContainer.nativeElement.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (err:any) { 
      this.loggerService.logError(this.ChatbotOldComponentError(err), "scrollBottom")
    }
  }
  ngAfterViewChecked() {
    if (this.elementRef.nativeElement.querySelector('#download-click')) {
      const elements = this.elementRef.nativeElement.querySelectorAll('#download-click');
    }
  }

  GetDynamicPopularQuestions(UserID: any, DomainID: any) {
    try{
    this.showLoader();
    this.chatbotService.GetDynamicPopularQuestions(UserID, DomainID).subscribe({
      next: (data) => {
        this.popularQuestions = [];
        if (data.status === "200") {
          if (data.response !== null && data.response !== undefined) {
            this.popularQuestionsShow = true;
            this.popularQuestions = data.response;
          }
        }
        this.hideLoader();
      },
      error: (error) => {
        this.hideLoader();
      },
      complete: () => {
        // This is optional and can be omitted if there's no additional logic to perform on completion.
      }
    });
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "GetDynamicPopularQuestions")
    return;
  }
  }

  extractSpecificWords(inputString: any) {
    let specificWords: string[] = [];
    const doc = nlp(inputString);
    doc.nouns().forEach((noun) => {
      specificWords.push(noun.text());
    });
    return specificWords;
  }
  VerifyUserAccessToChatBot(UserID: any, DomainID: any) {
    this.isUserHaveAccess = true;
  }

  GetDomainName() {
    if (environment.DomainName != null && environment.DomainName != "") {
      environment.DomainName = environment.DomainName.replace(/^"(.+(?="$))"$/, '$1');
    } else {
      environment.DomainName = this.configdata.DomainName;
    }
    this.moduleName = environment.DomainName;
  }

  GetDomainId(): Promise<void> {
    try{
    if (environment.IsDevelopment) {
      this.DomainID = 1;
      return Promise.resolve();
    }
    else {
      return new Promise((resolve, reject) => {
        this.showLoader();
        this.chatbotService.GetURFAllDomains().subscribe((data: any) => {
          if (data && data.code === 200 && Array.isArray(data.data)) {
            const filteredItems = data.data.filter((item: any) => item.domainPhrase === this.moduleName);
            if (filteredItems.length > 0) {
              this.DomainID = parseInt(filteredItems[0].value);
            } else {
              this.DomainID = 0;
            }
          } else {
            this.DomainID = 0;
          }
          this.hideLoader();
          resolve(); // Resolve the promise after setting DomainID
        }, error => {
          this.hideLoader();
          this.DomainID = 0;
          reject(error); // Reject the promise in case of an error
        });
      });
    }
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "GetDomainId")
    return Promise.resolve();
  }
  }

  GetURFModuleId(): Promise<void> {
    try{
    if (environment.IsDevelopment) {
      this.URFModuleId = 4;
      return Promise.resolve();
    }
    else {
      return new Promise((resolve, reject) => {
        this.showLoader();
        this.chatbotService.GetURFModuleId(this.DomainID).subscribe((data: any) => {
          if (data && data.code === 200 && Array.isArray(data.data)) {
            const filteredItems = data.data.filter((item: any) => item.displayName === 'Freya');
            if (filteredItems.length > 0) {
              this.URFModuleId = parseInt(filteredItems[0].id);
            } else {
              this.URFModuleId = 0;
            }
          } else {
            this.URFModuleId = 0;
          }
          this.hideLoader();
          resolve(); // Resolve the promise after setting DomainID
        }, error => {
          this.hideLoader();
          this.URFModuleId = 0;
          reject(error); // Reject the promise in case of an error
        });
      });
    }
  }
  catch(error:any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "GetURFModuleId")
    return Promise.resolve();
  }
  }

  filterDataByDescriptionAndModuleName(data: any, moduleName: string): number[] {
    // Validate data structure
    if (data && data.code === "200" && Array.isArray(data.data)) {
      // Filter data based on description and moduleName
      const filteredItems = data.data.filter((item: any) =>
        item.description === moduleName
      );

      // Extract and return ids from filtered items
      return filteredItems.map((item: any) => item.id);
    } else {
      // Return an empty array if data is not valid
      return [];
    }
  }

  GetDataPrivilegesForUser(UserID: any, DomainID: any) {
    this.Markets = [];
  }


  resetChatState() {
    this.isResponseScroll = false;
    this.IsResponseStreaming = false;
    this.isOptionsEnable = true;
    this.IsFirstTime = false;
    this.IsNewChat = false;
    this.txtChat = "";
    this.followUpQuestions = [];
    this.followUpQuestionsShow = false;
  }

  async handleChange() {
    try{
    //this.resetChatState();
    this.scrollBottom();
    this.note = false;
    let sendVectorDbObj: any = {};
    sendVectorDbObj.type = 1;
    sendVectorDbObj.selectedVectorDbDataset = this.selectedVectorDbDataset;

    this.sharedService.changeSelectedValue(sendVectorDbObj);
    this.GetDomainName();
    
    // Update domains list if domain management is enabled
    if (this.isDomainManagementEnabled) {
      await this.updateDomainsList();
    }
    
    // Refresh domain selection using effective domain logic after module change
    this.currentSelectedDomain = this.getEffectiveDomain();
    
    this.ClickNewChat(true);
    this.stopStreaming()
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "handleChange")
    return;
  }
  }

  private formatDateToDB(date: Date): string {
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
    const milliseconds = date.getUTCMilliseconds().toString().padStart(3, '0');
    // Pad milliseconds to 6 digits (microseconds)
    const microseconds = milliseconds + '000';
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${microseconds}`;
  }

  async transformNewSessionDataToOldFormat(newData: any[]): Promise<any[]> {
    try{
    if (!Array.isArray(newData)) {
      this.loggerService.logError(this.ChatbotOldComponentError("New data is not an array or is empty"), "transformNewSessionDataToOldFormat")
      return [];
    }
    return newData.map((item: any) => ({
      session_id: item.thread_id,
      user_id: parseInt(item.user_id) || item.user_id,
      tenant_id: parseInt(item.tenant_id) || item.tenant_id,
      chat_name: item.thread_name,
      created_date: item.created_at,
      modified_date: item.updated_at,
      domain_id: (item.selected_domains && Array.isArray(item.selected_domains) && item.selected_domains.length > 0) ? item.selected_domains[0] : '',
      status: item.status ? 1 : 0, // Convert boolean to number
      module_name: (item.modules && Array.isArray(item.modules) && item.modules.length > 0) ? item.modules[0] : '',
      original_name: item.thread_name,
    }));
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "transformNewSessionDataToOldFormat")
    return [];
  }
  }

  async GetChatSessionsInfo(UserID: any, DomainID: any) : Promise<void> {
    try{
    const defaultDays = 30;
    const page = 1;
    const pageSize = 30;
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - defaultDays);

    // Format dates for API (using your formatDateToDB method)
    const startDateFormatted = this.formatDateToDB(startDate);
    const endDateFormatted = this.formatDateToDB(endDate);
    const version = 1.0;
    const modules :string[] = [];

    const seletcedDomain = [environment.DomainName];
    this.showLoader();
    this.chatbotService.GetChatSessions(UserID, this.tenantID,seletcedDomain, page, pageSize, startDateFormatted, endDateFormatted, version, modules).subscribe({
    next: async (response: HttpResponse<any>) => {
        this.hideLoader();
        if (response.status === 200) {

          if (response.body.data !== null && response.body.data !== undefined) {
            if (response.body.data !== null && response.body.data !== undefined && response.body.data.length > 0) {
              this.chatSessionList = await this.transformNewSessionDataToOldFormat(response.body.data);
              this.chatSessionList = Array.isArray(this.chatSessionList) ? this.chatSessionList.map((item: any) => ({ ...item, isChecked: false })) : [];
              this.IsFirstTime = false;
              this.IsNewChat = false; 
              this.ClickNewChat(true);
            } else {
              this.IsFirstTime = true;
              this.IsNewChat = false;
              this.chatSessionList = [];
            }
          }
          this.ConversationHistoryCount = this.getConversationHistoryCount();
        } else {
          this.chatSessionList = [];
        }
      },
      error: (error) => {
        this.hideLoader();
        // Handle error
      },
      complete: () => {
        // Handle completion if necessary
      }
    });
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "GetChatSessionsInfo")
    return;
  }
  }


  generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0, // NOSONAR: Safe - used for non-security UI identifier
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }


  ClickNewChat(isNewChatSession: boolean) {
    try{
    // localStorage.clear();
    setTimeout(() => {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.adjustHeight();
      }
    });
    if (this.IsResponseStreaming) {
      const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];
      let chatSessionName = this.extractChatSessionName(this.currentSessionId[0].chat_name);
      this.saveChatResponseAndUpdateUI(latestObject, "", chatSessionName, this.currentSessionId[0].ModuleDisplayName);
      this.stopStreaming();
      this.txtChat = "";
    }
    this.IsResponseStreaming = false;
    this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_selected: false }));

    this.isResponseScroll = true;
    let newChatItem = this.chatSessionList.filter((item: { chat_name: any; }) =>
      item.chat_name == "New Topic"
    );
    this.currentSessionId = this.chatSessionList.filter((item: { is_selected: boolean; }) =>
      item.is_selected
    );
    if (!this.IsNewChat && isNewChatSession) {
      this.ChatQueriesList = [];
      this.IsNewChat = true;
      if (newChatItem.length == 0) {
        this.chatSessionList = this.chatSessionList?.map((item: any) => ({ ...item, is_selected: false }));
        const newItem = { session_id: this.generateGuid(), user_id: this.UserID, chat_name: "New Topic", domain_id: this.DomainID, is_selected: true, is_edited: false, original_name: "New Topic", is_available: false };
        if (this.chatSessionList && this.chatSessionList.length > 0) {
          this.chatSessionList.unshift(newItem);
        }
        else {
          this.chatSessionList.push(newItem);
        }
      }
    }
    const existingChatSessionsCount = this.chatSessionList.filter((item: any) => item.chat_name !== 'New Topic').length;
    if (existingChatSessionsCount > 30) {
      this.chatSessionList.pop();
    }
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "ClickNewChat")
    return;
  }
}

  startTypingAnimation() {
    let currentIndex = 0;
    const typingSpeed = 3000; // Adjust this to control typing speed (milliseconds per character)

    const typingInterval = setInterval(() => {
      if (currentIndex < this.answer.length) {
        this.typedText += this.answer[currentIndex];
        currentIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, typingSpeed);
  }

  // Add a method to stop stdeb1ugger;handlecreaming
  private stopStreaming(): void {
    if (this.streamingSubscription) {
      this.streamingSubscription.unsubscribe(); // Stop receiving data
      this.streamingSubscription = null; // Reset the subscription reference
      this.IsResponseStreaming = false; // Ensure this flag is set to false
      this.IsLoader = false;
    }
  }

  // At the beginning of your component class, add a property for the subscription
  private streamingSubscription: Subscription | null = null;

  // Function to validate JSON string
  isValidJsonString(str: string): boolean {
    const jsonRegex = /^[\],:{}\s]*$/
      .test(str.replace(/\\["\\\/bfnrtu]/g, '@')
        .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
        .replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
    return jsonRegex;
  }

  parseJsonSafely(jsonLikeString: string): any {
    try {
      // Replace single quotes with double quotes
      let sanitizedString = jsonLikeString.replace(/'/g, '"');

      // Attempt to replace known issues that can prevent parsing,
      // like unescaped newlines (this step might need adjustments based on actual string content)
      sanitizedString = sanitizedString.replace(/\n/g, '\\n');

      // Parse the sanitized string
      const jsonObject = JSON.parse(sanitizedString);
      return jsonObject;
    } catch (error:any) {
      this.loggerService.logError(this.ChatbotOldComponentError(error), "parseJsonSafely")
      return null; // or handle error as needed
    }
  }

  stopStreamingResponse() {
    if (this.streamingSubscription) {
      this.streamingSubscription.unsubscribe(); // Stop receiving data
      this.streamingSubscription = null; // Reset the subscription reference
      this.IsResponseStreaming = false; // Ensure this flag is set to false
      this.displayStopStreaming = false;
      const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];
      let chatSessionName = this.extractChatSessionName(this.currentSessionId[0].chat_name);
      this.saveChatResponseAndUpdateUI(latestObject, "", chatSessionName, this.currentSessionId[0].ModuleDisplayName);

    }
  }


  /* istanbul ignore next */
  SendRequest(isUpdateQuestion: boolean): void {
    try {
      this.showLoader();
      this.chatbotService.CheckDatasetAPIHealth().subscribe({
        next: (response: any) => {
          if (response === 200) {
            this.CallSendRequest(isUpdateQuestion);
          } 
          else if (response == 309) {
            this.handleError("Internet connection lost. Please check your network and try again.", response);
          }
          else {
            this.handleError("DS API health check failed.", response);
          }
        },
        error: (error: any) => {
          this.handleError("DS API health check failed.", error);
        }
      });
    } catch (error: any) {
      const log_error_message = "Error occurred during sending chat request. Please contact support or the administrator team. " +
        (error.message + " | " + error.stack)
      this.loggerService.logError(this.ChatbotOldComponentError(log_error_message), "saveChatResponse")
      this.showCustomErrorMessage("saveChatResponse",
        config.Apology_message,
        log_error_message
      );
    }
  }

  handleError(context: string, error: any): void {
    try{
    this.hideLoader();
    if (error == 309) {
      const log_error_message = `Internet connection lost. Please check your network and try again.`+
        (typeof error === 'object' ? error.message + " | " + error.stack : "Status Code : " + error.toString())
      this.loggerService.logError(this.ChatbotOldComponentError(log_error_message), "saveChatResponse")
      this.showPopupMessage(
        "HealthCheck",
        `Internet connection lost. Please check your network and try again.`,
        log_error_message
      );
    }
    else {
      const log_error_message = `${context}. Please contact support team If issue persist`+
        (typeof error === 'object' ? error.message + " | " + error.stack : "Status Code : " + error.toString())
      this.loggerService.logError(this.ChatbotOldComponentError(log_error_message), "saveChatResponse")
      this.showPopupMessage(
        "HealthCheck",
        config.Apology_message,
        log_error_message
      );
    }
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "handleError")
    return;
  }
  }
  isValidJson(jsonString: string): boolean {
    try {
      JSON.parse(jsonString);
      return true;
    } catch (e) {
      this.loggerService.logError(this.ChatbotOldComponentError(e), "isValidJson")
      return false;
    }
  }
  /* istanbul ignore next */
  CallSendRequest(isUpdateQuestion: boolean): void {
    try {
      if (isUpdateQuestion) {
        this.txtChat = this.updateQuestion;
      }
      else{
        this.prompt = 'default';
        this.txtChat = this.txtChat?.trim();
          if (this.txtChat === undefined || this.txtChat === null || this.txtChat === "") {
            this.hideLoader();
            return;
          }
      }
      this.followUpQuestions = [];
      this.followUpQuestionsShow = false;
      this.sessionIdArray = [];
      this.note = false;
      
      this.showLoader();
      this.defaultChat = true;
      let sessionId;
      this.currentSessionId = this.chatSessionList.filter((item: { is_selected: boolean; }) => item.is_selected);
      if (!this.currentSessionId?.length) {
        this.ClickNewChat(true);
      }
      else {
        const chatHistoryCount = this.chatSessionList.length;
        if (chatHistoryCount > 30) {
          this.chatSessionList.pop();
        }
      }

      if (this.currentSessionId == null || this.currentSessionId.length == 0) {
        this.chatSessionList[0].is_selected = true;
        this.currentSessionId.push(this.chatSessionList[0]);
        this.currentSessionId[0].chat_name = this.getOptimizedName(this.txtChat);
        this.currentSessionId[0].module_name = this.configdata.DisplayName;
      }

      this.IsNewChat = false;
      this.loginId = this.UserID;
      if (!this.currentSessionId[0].is_available || (this.currentSessionId[0].is_available && this.currentSessionId[0].chat_name == "New Topic")) {
        this.chatSessionList[0].chat_name = this.getOptimizedName(this.txtChat);
        this.chatSessionList[0].module_name = this.configdata.DisplayName;
        this.ConversationHistoryCount = this.getConversationHistoryCount();
      }

      this.sessionIdArray.push(this.currentSessionId[0].session_id);
      const actualModuleName = this.configdata && this.configdata.actual_module_name ? this.configdata.actual_module_name : '';
      this.data = {
        Question: this.txtChat,
        ModuleName: this.isDomainManagementEnabled ? this.getDomainFullName(this.currentSelectedDomain || this.allDomainNamesList[0]) : (this.configdata.api_module_name ? this.configdata.api_module_name : (this.configdata.module_Name == undefined || this.configdata.module_Name == null) ? "" : this.configdata.module_Name),
        UserId: this.UserID,
        SessionId: this.sessionIdArray,
        ChatSessionName: this.currentSessionId[0].chat_name,
        DomainId: this.isDomainManagementEnabled ? (this.currentSelectedDomain ? this.domainMapping(this.currentSelectedDomain) : this.domainMapping(this.allDomainNamesList[0])) : this.DomainID,
        prompt: this.prompt,
        ChatHistory: this.ChatQueriesList.map((item: { question: any; answer: any; }) => ({ Q: item.question, A: item.answer })).slice(0, 20),
        DataPrivileges: this.userDataPrivileges.length > 0 ? this.userDataPrivileges : [],
        Markets: this.Markets.length > 0 ? this.Markets : (this.configdata.MarketsPayloadRequired ? this.configdata.Countries : []),
        tenantID: this.configdata.default_tenant_id,
        streamResponseURL: this.streamResponseURL,
        ter: this.xApiKey,
        ModuleDisplayName: this.configdata.DisplayName,
        SubModuleName: this.isDomainManagementEnabled ? (this.currentSelectedDomain ? this.currentSelectedDomain : this.allDomainNamesList[0]) : environment.DomainName,
        SessionModuleName: this.currentSessionId[0].ModuleDisplayName,
        Privileges: this.Privileges,// JSON.parse(this.Privileges.replace(/^"(.+(?="$))"$/, '$1')),
        DomainName: this.isDomainManagementEnabled ? (this.currentSelectedDomain ? this.currentSelectedDomain : this.allDomainNamesList[0]) : environment.DomainName,
        Access_Token: environment.Access_Token
      }

      if (this.configdata.IsStreamingEnabled) {
        let loop = 0;
        let metadata: any[] = [];
        let preValue = "";
        let full_response = "";
        let buffer = '';
        this.ChatQueriesObj = {
          question: this.txtChat, answer: "", LikeClassAdded: null, disLikeClassAdded: null, LongText: null, RegenerateText: null,
          sessionid: null, ShotText: null, Comments: "", pk_chathistoryid: 0, metadata: []
        };
        if (!Array.isArray(this.ChatQueriesList)) {
          this.ChatQueriesList = [];
        }
        if (!Array.isArray(this.ChatQueriesList)) {
      this.ChatQueriesList = [];
    }
    this.ChatQueriesList?.push(this.ChatQueriesObj);
        this.isOptionsEnable = false;
        let zeroEventCount = 0;
        let isErrorFound = false;
        try {
          // Modify the subscription logic to use the streamingSubscription property
          this.streamingSubscription = this.chatbotService.callChunkedApi(this.data).subscribe((event: HttpEvent<any>) => {
            try {
              const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];

              this.txtChat = "";
              if (event.type == 0) {
                zeroEventCount = zeroEventCount + 1;
              }
              if (zeroEventCount >= 3 && !isErrorFound) {
                isErrorFound = true;
                this.hideLoader();

                latestObject.answer += "We apologize for the inconvenience. It seems the service is currently unavailable. Please try again later, or feel free to contact our support team for assistance. Thank you for your patience.";
                latestObject.metadata = {};
                this.isOptionsEnable = true;
                setTimeout(() => this.scrollBottom(), 0);
                this.IsFirstTime = false;
                this.IsNewChat = false;
                this.txtChat = "";
                this.followUpQuestions = [];
                this.followUpQuestionsShow = false;
                this.scrollBottom();
                this.note = false;
              }
              if (this.IsFirstTime) {
                this.IsFirstTime = false;
              }
              if (!isErrorFound) {
                if (event.type === HttpEventType.UploadProgress) {
                  this.IsResponseStreaming = true;
                } else if (event.type === HttpEventType.DownloadProgress && this.IsResponseStreaming) { //  && this.IsResponseStreaming
                  let data = event;
                  let partialText = JSON.parse(JSON.stringify(data)).partialText;
                  let match;
                  if (partialText) {
                    let aclVal = partialText;
                    let splData = aclVal.replace(preValue, '').split('data:');
                    preValue = partialText;
                    if (splData.length > 0) {
                      splData.forEach((sData: string) => {
                        try {
                          const trimmed = sData.trim();
                          if (
                            trimmed === "" ||
                            trimmed.startsWith(": ping")
                          ) {
                            return;
                          }
                          buffer += trimmed;
                          // Try to parse the buffer as JSON
                          try {
                            // Use regex to extract JSON object from the buffer
                            // const jsonMatch = buffer.match(/\{.*\}/s);
                            const jsonObject = JSON.parse(buffer);
                            if (jsonObject) {

                              // Clear the buffer after successful parse
                              buffer = '';

                              // Process the JSON object
                              let jsonData = jsonObject;

                              // Process newlines in the value if it's a string
                              if (typeof jsonData.value === 'string') {
                                jsonData.value = jsonData.value
                                  .replace(/\\n\\n/g, '<br><br>')
                                  .replace(/\\n/g, '<br>')
                                  .replace(/\n\n/g, '<br><br>')
                                  .replace(/\n/g, '<br>');
                              }

                              const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];

                              // Handle different response types
                              if (jsonData.type == "streaming") {
                                this.hideLoader();
                                this.displayStopStreaming = true;
                                latestObject.answer += jsonData.value;
                                setTimeout(() => {
                                  this.scrollBottom();
                                  // Ensure arrays remain arrays after async operation
                                  if (!Array.isArray(this.followUpQuestions)) this.followUpQuestions = [];
                                  if (!Array.isArray(latestObject.followUpQuestions)) latestObject.followUpQuestions = [];
                                }, 0);
                                this.followUpQuestions = [];
                                this.followUpQuestionsShow = false;
                                latestObject.followUpQuestions = [];
                                latestObject.metadata = {};
                              } else if ((jsonData.type === "error" || jsonData.type == "single_response") && this.IsResponseStreaming) {
                                this.IsResponseStreaming = false;
                                if (this.autoResizeDirective) {
                                  this.autoResizeDirective.resetHeight();
                                }
                                latestObject.answer = jsonData.value;
                                setTimeout(() => {
                                  this.scrollBottom();
                                  // Ensure arrays remain arrays after async operation
                                  const latestObj = this.ChatQueriesList[this.ChatQueriesList?.length - 1];
                                  if (latestObj && !Array.isArray(latestObj.followUpQuestions)) latestObj.followUpQuestions = [];
                                  if (!Array.isArray(this.followUpQuestions)) this.followUpQuestions = [];
                                }, 0);
                                let chatSessionName = this.extractChatSessionName(this.currentSessionId[0].chat_name);
                                this.saveChatResponseAndUpdateUI(latestObject, full_response, chatSessionName, this.currentSessionId[0].ModuleDisplayName);
                              } else if (jsonData.type === "IsInternet" && this.IsResponseStreaming) {
                                this.note = !!jsonData.value;
                              } else if (jsonData.type === "metadata") {
                                if (jsonData.value && Object.keys(jsonData.value).length > 0) {
                                  this.IsLoader = true;
                                }
                                if (jsonData.value && Array.isArray(jsonData.value)){
                                  metadata = [jsonData.value];
                                }
                              } else if (jsonData.type == "follow_up_q") {
                                this.followUpQuestions = [];
                                this.followUpQuestionsShow = false;
                                if (jsonData.value != undefined && Array.isArray(jsonData.value) && jsonData.value.length > 0) {
                                  this.followUpQuestionsShow = true;
                                  this.followUpQuestions = jsonData.value;
                                  latestObject.followUpQuestions = [jsonData.value];
                                } else {
                                  // Ensure arrays are always properly initialized
                                  this.followUpQuestions = [];
                                  latestObject.followUpQuestions = [];
                                }
                              } else if (jsonData.type == "response_done" && this.IsResponseStreaming) {
                                this.IsFirstTime = false;
                                this.IsNewChat = false;
                                this.txtChat = "";
                                this.scrollBottom();

                                if (latestObject) {
                                  // Get the current date and time in UTC
                                  const dateObject = this.get_current_chat_datetime();
                                  // Use the date object as needed
                                  latestObject.modified_date = this.format_date_time(dateObject);

                                  // Define keyValuePairs with an index signature that allows number keys
                                  let sortedMetadata: { [key: string]: any } = {};
                                  // Define percentiles as a string array
                                  let percentiles: string[] = [];
                                  let percentilesOnly: number[] = [];

                                  // Process metadata
                                  if (Array.isArray(metadata) && metadata.length > 0 && typeof metadata[0] === 'object' && Object.keys(metadata[0]).length > 0) {
                                    if (Object.keys(metadata[0]).length > 0) {
                                      metadata.forEach((item: any) => {
                                        // Iterate over the properties of the item object
                                        for (const key in item) {
                                          if (item.hasOwnProperty(key)) {
                                            const percentileValue = item[key].hasOwnProperty('percentile') ? item[key].percentile + "_" + key : "no_percentile" + "_" + key; // Check if percentile exists, else use key
                                            percentiles.push(percentileValue);
                                            percentilesOnly.push(item[key].hasOwnProperty('percentile') ? item[key].percentile : null);
                                            percentilesOnly = percentilesOnly.filter(value => value !== null);
                                          }
                                        }
                                      });
                                    }
                                  } else {
                                    // Handle the case when metadata is empty or metadata[0] has no properties
                                    this.loggerService.logError(this.ChatbotOldComponentError("No metadata to process or metadata[0] is empty"), "getStreamingResponseData")
                                  }

                                  // Sort the percentilesOnly array in descending order
                                  percentilesOnly.sort((a, b) => b - a);

                                  for (let i = 0; i < percentiles.length; i++) {
                                    const percentile = percentiles[i];
                                    if (percentile.startsWith('no_percentile_')) {
                                      const splitPercentile = percentile.split('no_percentile_');
                                      const lastIndexValue = splitPercentile[splitPercentile.length - 1];
                                      let filteredItem;
                                      metadata.forEach((item: any) => {
                                        filteredItem = item[lastIndexValue];
                                      });
                                      sortedMetadata[i + 1] = filteredItem;
                                    } else {
                                      const perValue = percentilesOnly[i];
                                      let filteredItem: any[] = [];
                                      metadata.forEach((item: any) => {
                                        filteredItem = [];
                                        filteredItem = Object.values(item).filter((item_data: any) => {
                                          return item_data.percentile === perValue;
                                        });
                                      });
                                      if (filteredItem && filteredItem.length > 0) {
                                        sortedMetadata[i + 1] = filteredItem[0];
                                      }
                                    }
                                  }
                                  latestObject.metadata = {sortedMetadata};
                                }

                                this.isOptionsEnable = true;
                              } else if (jsonData.type == "full_response" && this.IsResponseStreaming) {
                                const finalToken = jsonData.value?.answer?.text?.split(" ").slice(-1)[0];
                                if (this.autoResizeDirective) {
                                  this.autoResizeDirective.resetHeight();
                                }
                                full_response = jsonData.value;
                                this.IsLoader = false;
                                this.IsResponseStreaming = false;
                                this.displayStopStreaming = false;
                                let chatSessionName = this.extractChatSessionName(this.currentSessionId[0].chat_name);
                                this.saveChatResponseAndUpdateUI(latestObject, full_response, chatSessionName, this.currentSessionId[0].ModuleDisplayName);
                              }
                            }
                          } catch (parseError:any) {
                            // If parsing fails, we'll keep the buffer and wait for more data
                            this.loggerService.logError(this.ChatbotOldComponentError(parseError), "parseJsonSafely")

                          }
                        } catch (error: any) {
                          this.hideLoader();
                          this.displayStopStreaming = false;
                          const log_error_message = `Error occurred during chat response parsing chunk: ${sData}. Please contact support or the administrator team.` +
                            (error.message + " | " + error.stack);
                          this.loggerService.logError(this.ChatbotOldComponentError(log_error_message), "getStreamingResponseData")
                            this.showCustomErrorMessage("Chatstream",
                            config.Apology_message,
                            log_error_message
                          );
                        }
                      });
                    }
                  } else {
                    this.loggerService.logError(this.ChatbotOldComponentError("None partial Text"), "getStreamingResponseData")
                  }
                } else if (event.type === HttpEventType.Response) {
                  this.hideLoader();
                } else if (!this.IsResponseStreaming && event.type != 0) {
                  let chatSessionName = this.extractChatSessionName(this.currentSessionId[0].chat_name);
                  this.saveChatResponseAndUpdateUI(latestObject, full_response, chatSessionName, this.currentSessionId[0].ModuleDisplayName);
                  this.stopStreaming();
                }
              }
            }
            catch (error: any) {
              this.hideLoader();
              this.displayStopStreaming = false;
              const log_error_message = `Error occurred while calling the chat response API input :${this.data}. Please contact support or the administrator team.`+
                (error.message + " | " + error.stack)
              this.loggerService.logError(this.ChatbotOldComponentError(log_error_message), "getStreamingResponseData")
                this.showCustomErrorMessage("Chatstream",
                config.Apology_message,
                log_error_message
              );
            }
          });
        }
        catch (error: any) {
          this.hideLoader();
          this.displayStopStreaming = false;
          const log_error_message = `Error occurred while connecting chat streaming response :${this.ChatQueriesObj}. Please contact support or the administrator team.`+
            (error.message + " | " + error.stack)
          this.loggerService.logError(this.ChatbotOldComponentError(log_error_message), "getStreamingResponseData")
            this.showCustomErrorMessage("Chatstream",
            config.Apology_message,
            log_error_message
          );
        }
      } else {
        this.loggerService.logError(this.ChatbotOldComponentError("Error occurred while connecting chat streaming response"), "getStreamingResponseData")
      }
    } catch (error: any) {
      const log_error_message = `Error occurred during sending chat request :${isUpdateQuestion}. Please contact support or the administrator team.`+
        (error.message + " | " + error.stack)
      this.loggerService.logError(this.ChatbotOldComponentError(log_error_message), "getStreamingResponseData")
      this.showCustomErrorMessage("Chatstream",
        config.Apology_message,
        log_error_message
      );
    }
  }

  get_current_chat_datetime() {
    const utcDate = new Date().toISOString();
    // Create a Date object from the UTC date string
    const now = new Date();
    // Format each component to ensure the correct format
    const year = now.getUTCFullYear();
    const month = (now.getUTCMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = now.getUTCDate().toString().padStart(2, '0');
    const hours = now.getUTCHours().toString().padStart(2, '0');
    const minutes = now.getUTCMinutes().toString().padStart(2, '0');
    const seconds = now.getUTCSeconds().toString().padStart(2, '0');
    const milliseconds = now.getUTCMilliseconds().toString().padStart(3, '0');

    // Add fractional seconds up to six digits
    const microseconds = `${milliseconds}000`.slice(0, 6);

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${microseconds}`;
    const dateObject = new Date(formattedDate);
    return dateObject;
  }

  /* istanbul ignore next */
  updateSessionChatHistory(latestObject: any, chatSessionName: any, module_name: any): void {
    try{
    this.data = {
      SessionId: this.sessionIdArray,
      SessionChatHistory: window.btoa(unescape(encodeURIComponent(localStorage.getItem('SessionChatHistory') ?? ''))),
    };
    this.data = {
      Question: latestObject.question,
      UserId: this.UserID,
      SessionId: this.sessionIdArray,
      ChatSessionName: chatSessionName,
      DomainId: this.DomainID,
      prompt: this.prompt,
      ChatHistory: this.ChatQueriesList.length == 1 ? [] : this.ChatQueriesList.map((item: { question: any; answer: any; }) => ({ Q: item.question, A: item.answer })).slice(0, 20),
      tenantID: this.tenantID,
      Answer: window.btoa(unescape(encodeURIComponent(latestObject.answer))),
      ModuleDisplayName: this.configdata.DisplayName.replace(/^@/, ''),
      SubModuleName: this.configdata.actual_module_Name || '',
      SessionModuleName: module_name, //this.currentSessionId[0].ModuleDisplayName
    };

    this.chatbotService.CallUpdateSessionChatHistory(this.data).subscribe((response: any) => {
      if (response.status == "200") {
      }
    });
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "updateSessionChatHistory")
    return;
  }
  }


  extractChatSessionName(chatName: string): string {
    return chatName;
  }

  /* istanbul ignore next */
  saveChatResponseAndUpdateUI(latestObject: any, full_response: any, chatSessionName: string, module_name: string): void {
    try{
    this.data = {
      user_id: this.UserID,
      tenant_id: this.tenantID,
      thread_id: this.sessionIdArray[0],
      selected_domains: this.isDomainManagementEnabled ? [this.currentSelectedDomain]: this.domainMapping(this.DomainID),
      question: latestObject.question,
      answer: {
        text: latestObject.answer,
        image_visualization: []
      },
      modules : [this.configdata.DisplayName.replace(/^@/, '')],
      source_metadata: {
        references: this.convertMetadataForSaving(this.convertMetadataForDisplay(latestObject.metadata)),
        follow_up_questions: this.convertFollowUpQuestionsForSaving(latestObject.followUpQuestions),
      }
    }
    this.chatbotService.saveChatResponse(this.data).subscribe((data) => {
      if (data.status.toString() == "200") {
        this.hideLoader();
        this.isOptionsEnable = true;
        let pk_chathistoryid = 0;
        if (data.body?.data?.response_id) {
          // New structure: response_id is directly in data object
          pk_chathistoryid = data.body.data.response_id;
        } else if (data.body?.data?.pk_chat_history_id) {
          // Fallback for old structure
          pk_chathistoryid = data.body.data.pk_chat_history_id;
        } else if (Array.isArray(data.body?.data)) {
          // Fallback for array structure
          data.body.data.forEach((item: any) => {
            pk_chathistoryid = item.pk_chat_history_id || item.response_id;
          });
        }
        latestObject.pk_chathistoryid = pk_chathistoryid;
        this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_available: true }));
      }
      else if (data.status.toString() == "309") {
        this.handleError("Internet connection lost. Please check your network and try again.", data.status.toString());
      }
      else {
        this.hideLoader();
        // if (data.status.toString() !== "407") {
        //   this.answer = data.response;
        // }
        let pk_chathistoryid = 0;
        data.body?.data?.forEach((item: any) => {
          pk_chathistoryid = item.pk_chat_history_id;
        });

        if (latestObject.pk_chathistoryid == 0) {
          latestObject.pk_chathistoryid = pk_chathistoryid;
        } else {
          this.ChatQueriesObj = {
            question: this.txtChat, answer: "", LikeClassAdded: null, disLikeClassAdded: null, LongText: null, RegenerateText: null,
            sessionid: null, ShotText: null, Comments: "", pk_chathistoryid: 0, metadata: []
          };
          if (!Array.isArray(this.ChatQueriesList)) {
      this.ChatQueriesList = [];
    }
    this.ChatQueriesList?.push(this.ChatQueriesObj);
        }
        if (data.status.toString() !== "407") {
          // latestObject.answer = data.response;
          this.CustomErrorMessageText = config.Apology_message;
        }

        this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_available: true }));
        this.IsFirstTime = false;
        this.IsNewChat = false;
        this.txtChat = "";
        this.followUpQuestions = [];
        this.followUpQuestionsShow = false;
        this.note = false;
        this.isOptionsEnable = true;
        const log_error_message = (data.error_message + (data.error ?? "Unknown error occurred while saving chat response"))
        this.loggerService.logError(this.ChatbotOldComponentError(log_error_message), "saveChatResponse")
        this.showCustomErrorMessage("saveChatResponse",
          config.Apology_message, log_error_message);
      }
    });
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "saveChatResponseAndUpdateUI")
    return;
  }
  }

  showCustomErrorMessage(functionname: string,errorMessage: string, error: string): void {
    const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];
      if (latestObject) {
          latestObject.answer = errorMessage;
          latestObject.metadata = {};
        }
  }

  showPopupMessage(functionname: string,errorMessage: string, error: string):void {
    // this.logClientError(functionname, error);
    this.IsCustomErrorMessageVisible = true;
    this.CustomErrorMessageText = errorMessage ?? "Error Occurred. Please try again or contact support.";
    setTimeout(() => {
      this.IsCustomErrorMessageVisible = false;
      this.CustomErrorMessageText = "";
    }, 15000);
  }



  getStreamingResponseData() {
    try{
    this.isOptionsEnable = false;
    let loop = 0;
    let metadata: any[] = [];
    this.ChatQueriesObj = {
      question: this.questiontxt, answer: "", LikeClassAdded: null, disLikeClassAdded: null, LongText: null, RegenerateText: null,
      sessionid: null, ShotText: null, Comments: "", pk_chathistoryid: 0, metadata: [], FeedbackOptions: Array.isArray(this.configdata.FeedbackOptions) ? this.configdata.FeedbackOptions : [], AdditionalComments: ""
    };
    if (!Array.isArray(this.ChatQueriesList)) {
      this.ChatQueriesList = [];
    }
    this.ChatQueriesList?.push(this.ChatQueriesObj);

    this.hubConnectionBuilder = new HubConnectionBuilder()
      .withUrl(environment.baseUrl + '/Streaming')
      .configureLogging(LogLevel.Information)
      .build();
    this.hubConnectionBuilder
      .start()
      .then(() => {})
      .catch(err => this.loggerService.logError(this.ChatbotOldComponentError(err), "getStreamingResponseData"));

    /* istanbul ignore next */
    this.hubConnectionBuilder.on('SendStreamDatatoClient', (data: any) => {
      loop = loop + 1;
      // Safe regex with bounded quantifier
      const jsonMatch = data[0].match(/\{[\s\S]{0,100000}\}/);
      if (jsonMatch) {
        jsonMatch[0] = jsonMatch[0].replaceAll("\\n\\n", "<br><br>");
        jsonMatch[0] = jsonMatch[0].replaceAll("\\n", "<br>");
        jsonMatch[0] = jsonMatch[0].replaceAll("\n\n", "<br><br>");
        jsonMatch[0] = jsonMatch[0].replaceAll("\n", "<br>");
        const jsonData = JSON.parse(jsonMatch[0]);
        if (jsonData.type == "streaming") {
          const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];
          setTimeout(() => { latestObject.answer += jsonData.value; }, (loop * (this.configdata.StreamResponseLoopTime)));
        }
        if (jsonData.type == "IsInternet") {
          this.note = false;
          if (jsonData.value)
            this.note = true;
        }
        if (jsonData.type == "metadata") {
          metadata = [jsonData.value];
        }
        if (jsonData.type == "follow_up_q") {
          this.followUpQuestions = [];
          this.followUpQuestionsShow = false;
          if (jsonData.value != undefined && Array.isArray(jsonData.value) && jsonData.value.length > 0) {
            setTimeout(() => {
              this.followUpQuestionsShow = true;
              this.followUpQuestions = jsonData.value;
            }, (loop * (this.configdata.StreamResponseLoopTime)));
          } else {
            // Ensure arrays are always properly initialized
            this.followUpQuestions = [];
          }
        }
        if (jsonData.type == "response_done") {
          this.hubConnectionBuilder.stop();
          this.IsFirstTime = false;
          this.IsNewChat = false;
          this.questiontxt = "";
          this.scrollBottom();

          setTimeout(() => {
            const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];
            if (latestObject) {
              // Ensure metadata is in the correct format for templates
              if (Array.isArray(metadata) && metadata.length > 0) {
                latestObject.metadata = {sortedMetadata: metadata[0]};
              } else {
                latestObject.metadata = {};
              }
            }
            this.isOptionsEnable = true;
          }, (loop * (this.configdata.StreamResponseLoopTime)));
        }
      }
    });
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "getStreamingResponseData")
    return;
  }
  }

  getOptimizedName(question: string): string {
    return question;
  }


  LeaveChatSession(index: number) {
    if (this.chatSessionList[index].chat_name.trim() == '' || this.chatSessionList[index].chat_name.trim() == undefined) {
      this.chatSessionList[index].chat_name = this.chatSessionList[index].original_name.trim();
    }
  }
  aclick(path: any) {
    window.location.href = path;
  }
  FollowUpQuestionClick(fq: any) {
    this.updateQuestion = fq;
    this.prompt = 'default';
    this.SendRequest(true);
    setTimeout(() => {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.adjustHeight();
      }
    });
  }
  Deletepopup(index: number) {
    this.chatSessionList.forEach((item: any, i: any) => {
      if (i === index) {
        item.isDeleting = true;
      } else {
        item.isDeleting = false;
      }
      item.is_edited = false;
    });
  }
  Editpopup(index: number) {
    this.chatSessionList.forEach((item: any, i: any) => {
      if (i === index) {
        item.is_edited = true;
        item.original_name = item.chat_name;
      } else {
        item.is_edited = false;
      }
      item.isDeleting = false;
    });
  }
  disablepopup(index: number, event: MouseEvent) {
    this.isResponseScroll = false;

    if (this.chatSessionList[index]) {
      // Revert the chatname to the original name when cancel is clicked
      this.chatSessionList[index].chat_name = this.chatSessionList[index].original_name;
      this.chatSessionList[index].is_edited = false;
      this.chatSessionList[index].isDeleting = false;
    }
    this.hideLoader();
  }
  deletedisablepopup(index: number) {
    this.isResponseScroll = false;

    if (this.chatSessionList[index]) {
      this.chatSessionList[index].is_edited = false;
      this.chatSessionList[index].isDeleting = false;
    }
    this.hideLoader();
  }
  toggleDropdown(index: number, event: MouseEvent) {
    // Prevent the event from closing the dropdown immediately after opening it
    event.stopPropagation();

    // Close all dropdowns
    this.chatSessionList.forEach((item: any, i: any) => {
      if (i !== index) item.dropdownVisible = false;
    });

    // Toggle the current dropdown
    this.chatSessionList[index].dropdownVisible = !this.chatSessionList[index].dropdownVisible;

    // If the dropdown is now open, add a click listener to the document to close it when clicking outside
    if (this.chatSessionList[index].dropdownVisible) {
      setTimeout(() => { // Use setTimeout to delay the addition of the click listener to avoid immediate trigger
        document.addEventListener('click', this.closeDropdown.bind(this, index));
      }, 0);
    }
  }

  closeDropdown(index: number) {
    // Close the dropdown
    this.chatSessionList[index].dropdownVisible = false;

    // Remove the event listener to clean up
    document.removeEventListener('click', this.closeDropdown.bind(this, index));
  }
  EditChatSession(index: number) {
    this.resetChatState();
    this.chatSessionList[index].is_edited = true;
    this.chatSessionList[index].chat_name = this.chatSessionList[index].chat_name.trim();
    this.chatSessionList[index].original_name = this.chatSessionList[index].chat_name;

  }
  DeleteChatSession(index: any) {
    try{
    this.resetChatState();
    this.chatSessionList[index].isDeleting = false;
    this.isResponseScroll = true;
    this.DeleteSuccessMessage = true;
    setTimeout(() => {
      this.DeleteSuccessMessage = false;
    }, 4000);
    this.showLoader();
    let sessionid = this.chatSessionList[index].session_id;
    this.chatbotService.DeleteChatSession(sessionid, this.UserID, this.tenantID, this.DomainID).subscribe({
      next: (response: HttpResponse<any>) => {
        this.hideLoader();
        if (response.status === 200) {
          if (response.body && response.body.status === "Success" && response.body.data) {
              this.GetChatSessionsInfo(this.UserID, this.DomainID);
          }
          else {
            // Handle error case
          }
        }
        else{
          this.hideLoader();
          this.showPopupMessage(
            "DeleteChatSession",
            config.Apology_message,
            ""
          );
        }
      },
      error: (error: any) => {
        this.hideLoader();
        this.showPopupMessage(
          "DeleteChatSession",
          config.Apology_message,
          ""
        );
      },
      complete: () => {
        // Handle completion if necessary
      }
    });
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "DeleteChatSession")
    return;
  }
  }


  UpdateChatSession(index: number) {
    try{
    this.resetChatState();
    this.showLoader();
    this.ChatTitle = this.chatSessionList[index].original_name
    this.chatSessionList[index].is_edited = false;
    let chatname = this.chatSessionList[index].chat_name.trim();
    let sessionid = this.chatSessionList[index].session_id;
    if (chatname.trim() != '' && chatname.trim() != undefined) {
      this.chatbotService.UpdateSessionName(sessionid, chatname, this.UserID, this.tenantID, this.DomainID).subscribe({
        next: (response: HttpResponse<any>) => {
          this.hideLoader();
          if (response.status !== 200) {
            this.chatSessionList[index].chat_name = this.chatSessionList[index].original_name.trim();
            this.showPopupMessage(
              "UpdateChatSession",
              config.Apology_message,
              ""
            );
          }
          else {
            if (chatname !== this.ChatTitle) {
              this.EditSuccessMessage = true;
              setTimeout(() => {
                this.EditSuccessMessage = false;
              }, 4000);
            }
          }
        },
        error: (error) => {
          this.hideLoader();
          this.chatSessionList[index].chat_name = this.chatSessionList[index].original_name.trim();
          this.showPopupMessage(
            "UpdateChatSession",
            config.Apology_message,
            ""
          );
        },
        complete: () => {
          // This is optional and can be omitted if there's no additional logic to perform on completion.
        }
      });
    } else {
      this.chatSessionList[index].chat_name = this.chatSessionList[index].original_name.trim();
      this.hideLoader();
    }
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "UpdateChatSession")
    return;
  }
  }

  Cancel(index: number) {
    this.chatSessionList[index].is_edited = false;
    this.chatSessionList[index].chat_name = this.chatSessionList[index].original_name.trim();
    this.chatSessionList[index].is_edited = false;
  }

  EditSpecificQuestion(index: number) {
    this.editIndex = index;
    this.showEdit = true;
  }
  CancelSpecificQuestion(index: number) {
    this.editIndex = -1;
    this.showEdit = false;
  }
  onSpanInput(event: any) { this.editText = event.target.textContent; }

  SelectedSession(index: number) {
    this.resetChatState();
    this.txtChat = "";
    if (this.txtChat === "") {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.resetHeight();
      }
    }
    this.chatSessionList.forEach((item: any) => item.dropdownVisible = false);
    this.IsLikeSelected = true;
    this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_edited: false }));
    this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_available: true }));
    this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_selected: false }));
    this.chatSessionList[index].is_selected = true;
    this.GetChatHistory(this.chatSessionList[index].session_id.split(','));
  }

  isAnyOptionChecked(options: any[]): boolean {
    return options.some(option => option.IsChecked);
  }

  async transformNewChatHistoryToOldFormat(newData: any[]): Promise<any[]> {
    try{
    return newData.map((item: any) => {
      // Parse the answer if it's a JSON string
      let parsedAnswer = item?.answer || '';
      if (typeof item.answer === 'string') {
        try {
          const answerObj = JSON.parse(item.answer);
          parsedAnswer = answerObj.text || item?.answer || '';
        } catch (e) {
          // If parsing fails, use the original answer
          parsedAnswer = item?.answer || '';
        }
      }
  
      // Extract follow-up questions from source_metadata and convert to object format for metadata storage
      const followUpQuestionsFromAPI = item?.source_metadata?.follow_up_questions || [];
      const formattedFollowUpQuestions = this.convertFollowUpQuestionsForDisplay(followUpQuestionsFromAPI)[0] || [];
      
      // Handle metadata conversion from API format to display format
      let referencesForDisplay = {};
      if (item?.source_metadata?.references && Object.keys(item.source_metadata.references).length > 0) {
        // Check if references is in new format (with id, module_name, metadata structure)
        const references = item.source_metadata.references;
        const firstKey = Object.keys(references)[0];
        if (firstKey && references[firstKey] && 
            typeof references[firstKey] === 'object' && 
            'id' in references[firstKey] && 'module_name' in references[firstKey] && 'metadata' in references[firstKey]) {
          // Convert new format to old format for display
          referencesForDisplay = this.convertNewFormatToOldForDisplay(references);
        } else {
          // Already in old format
          referencesForDisplay = references;
        }
      }
      // If referencesForDisplay is still empty, ensure it's an empty object for consistency
      if (!referencesForDisplay || Object.keys(referencesForDisplay).length === 0) {
        referencesForDisplay = {};
      }

      // Create metadata object in old format
      const metadataObj = {
        follow_up_q: formattedFollowUpQuestions,
        IsInternet: false,
        module_name: (item?.modules && Array.isArray(item.modules) && item.modules.length > 0) ? item.modules[0] : 'regulations',
        answer: {
          metadata: Array.isArray(referencesForDisplay) && referencesForDisplay.length > 0
            ? referencesForDisplay[0]
            : referencesForDisplay,
          text: parsedAnswer
        },
        question: item?.question
      };

      return {
        pk_chathistoryid: item?.response_id, // Using response_id as pk_chathistoryid
        //fk_chatbotid: 4747, // Default value, you might need to adjust
        sessionid: item?.thread_id || '', // This should come from the request context
        module_name: (item?.modules && Array.isArray(item.modules) && item.modules.length > 0) ? item.modules[0] : '',
        chatname: item?.thread_name || '', // This should come from session context
        question: item?.question,
        answer: parsedAnswer,
        islike: item?.is_like,
        comments: item?.comments || '',
        feedback: item?.feedback || '',
        additionalcomments: '',
        metadata: JSON.stringify(metadataObj),
        modified_date: item?.updated_at,
      };
    });
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "transformNewChatHistoryToOldFormat")
    return [];
  }
  }

  async GetChatHistory(SessionID: string[]): Promise<void> {
    try{
    this.isOptionsEnable = true;
    this.isResponseScroll = true;
    this.note = false;
    this.errorMsg = "";
    this.showLoader();
    this.followUpQuestions = [];
    this.followUpQuestionsShow = false;
    this.SessionChatHistory = []
    this.data = {
      tenant_id: this.tenantID,
      user_id: this.UserID,
      thread_id: SessionID?.[0] || ''
    }
    this.chatbotService.GetChatHistoryAPI(this.data)
      .subscribe({
        next: async (response: HttpResponse<any>) => {
          this.hideLoader();
          if (response.status === 200) {

              if (response.body.data !== null && response.body.data !== undefined && response.body.data.length > 0) {
                this.ChatQueriesList = [];
                const transformedData = await this.transformNewChatHistoryToOldFormat(response.body.data);
                this.SessionChatHistory = transformedData[0].session_chat_history;
                localStorage.setItem('SessionChatHistory', transformedData[0].session_chat_history);
                transformedData.forEach((item: any) => {
                  const Module_Name = item.module_name?.trim().toUpperCase();
                  const Module_Info = Object.values(moduleDetails).find((module: any) =>
                    module.DisplayName.toUpperCase() === Module_Name
                  ) as ModuleInfo;
                  if (Module_Info) {
                    const module_value = Object.keys(moduleDetails).find(key => (moduleDetails as any)[key] === Module_Info) || '';
                    let selected_value: any = {};
                    selected_value.type = 1;
                    selected_value.selectedVectorDbDataset = {
                      name: Module_Info.DisplayName,
                      value: module_value,
                      default: false
                    };
                    this.sharedService.changeSelectedValue(selected_value);
                    const updatedDataset = this.vectorDbDatasets.find(dataset => dataset.value === selected_value.selectedVectorDbDataset.value);
                    if (updatedDataset) {
                      this.selectedVectorDbDataset = updatedDataset;
                    }
                  }
                  item.answer = item.answer.replaceAll("\\n\\n", "<br><br>");
                  item.answer = item.answer.replaceAll("\\n", "<br>");
                  item.answer = item.answer.replaceAll("\n\n", "<br><br>");
                  item.answer = item.answer.replaceAll("\n", "<br>");
                  const feedbackArray = Array.isArray(item.feedback) ? item.feedback : (item.feedback && typeof item.feedback === 'string' ? JSON.parse(item.feedback) : []);
                  let dislike = null;
                  if (typeof item.islike === 'boolean') {
                    dislike = !item.islike;
                  }
                  else {
                    item.islike = null;
                  }
                  this.ChatQueriesObj = {
                    pk_chathistoryid: item.pk_chathistoryid, question: item.question, answer: item.answer,
                    LikeClassAdded: item.islike, disLikeClassAdded: dislike, longtext: item.longtext,
                    regeneratetext: item.regeneratetext, sessionid: item.sessionid, shottext: item.shottext, comments: item.comments,
                    chatname: item.chatname,
                    AdditionalComments: typeof item.additionalcomments === 'string' ? item.additionalcomments : '',
                    FeedbackArray: feedbackArray,
                    FeedbackOptions: Array.isArray(this.configdata.FeedbackOptions) ? this.configdata.FeedbackOptions.map((element: any) => {
                      return {
                        ...element,
                        IsChecked: feedbackArray.includes(element.Id) ? true : false,
                        pk_chathistoryid: item.pk_chathistoryid,
                      };
                    }) : [],
                    metadata: (item?.metadata && JSON.parse(item?.metadata)?.answer && JSON.parse(item?.metadata)?.answer.metadata) ? {sortedMetadata: JSON.parse(item?.metadata)?.answer.metadata} : {},
                    followUpQuestions: (item?.metadata && JSON.parse(item?.metadata)?.follow_up_q && JSON.parse(item?.metadata)?.follow_up_q) ? [JSON.parse(item?.metadata)?.follow_up_q] : [],
                    modified_date: this.format_date_time(new Date(item.modified_date))
                  };
                  if (!Array.isArray(this.ChatQueriesList)) {
                  this.ChatQueriesList = [];
                }
                this.ChatQueriesList?.push(this.ChatQueriesObj);
                });
                this.ChatQueriesList = this.ChatQueriesList.reverse();
                this.FeedbackOptions = Array.isArray(this.ChatQueriesObj.FeedbackOptions) ? this.ChatQueriesObj.FeedbackOptions : [];
                this.IsFirstTime = false;
                this.IsNewChat = false;
                this.questiontxt = "";
                this.followUpQuestionsShow = true;
              } else {
                this.ChatQueriesList = [];
                this.IsFirstTime = false;
                this.IsNewChat = true;
              }
          }
        },
        error: (e) => { this.hideLoader(); }
      });
    }
    catch(error:any){
      this.loggerService.logError(this.ChatbotOldComponentError(error), "GetChatHistory")
      return;
    }
  }

  format_date_time(parsed_date: Date) {
    const date = new Date(parsed_date.getTime() - parsed_date.getTimezoneOffset() * 60000);

    const day = date.getDate().toString().padStart(2, '0'); // Ensure 2-digit day
    const month = date.toLocaleString('en-US', { month: 'short' }); // Short month name
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12; // Convert 24-hour to 12-hour format
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Ensure 2-digit minutes
    const seconds = date.getSeconds().toString().padStart(2, '0'); // Ensure 2-digit seconds
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

    const formattedDate = `${day}-${month}-${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
    return formattedDate;
  }

  viewFile(fileName: string, action_type: any, insight_id: any) {
    try{
    this.showLoader();
    this.isResponseScroll = false;
  
    this.chatbotService.ViewInsightFile(fileName, this.tenantID, insight_id).subscribe(response => {
      if(this.configdata.DownloadApiToggle){
        if (!response) {
          this.hideLoader();
          return;
        }
        fetch(response)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
          return response.blob();
        })
        .then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
          this.loggerService.logError(this.ChatbotOldComponentError(error), "viewFile")
        })
        .finally(() => {
          this.hideLoader();
        })
      }
      else{
        // Old API response is a Blob
        const blobUrl = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        this.hideLoader();
      }
    }, error => {
      this.loggerService.logError(this.ChatbotOldComponentError(error), "viewFile")
      this.hideLoader();
    });
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "viewFile")
    return;
  }
  }



  DocChat(displayname: any,insight_id:any) {
    this.showLoader();
    this.isResponseScroll = false;
    this.chatbotService.GetDocChatUrl(displayname,insight_id)
      .subscribe((data: any) => {
        this.hideLoader();
        if (data.status === "200") {
          if (data.response !== null && data.response !== undefined) {
            let EncyptedFileName = data.response;
            window.open(EncyptedFileName, '_blank');
          }
        }
      });
  }

  onAnchorRightClick(event: MouseEvent): void {
    this.isResponseScroll = false;
    if (event.which === 3 && event.button === 2) {
      event.preventDefault(); // Prevent default right-click context menu
    }
  }

  LikeDisLike(chatdata: any, ChatHistoryID: number, IsLike: boolean) {
    try{

    this.isResponseScroll = false;
    this.IsLikeSelected = !IsLike;
    if (IsLike) {
      chatdata.LikeClassAdded = false;
      let isReset = this.VerifyIsReset(chatdata.LikeClassAdded, chatdata.disLikeClassAdded);
      this.chatbotService.UpdateDisLikeFeedback(ChatHistoryID, chatdata.LikeClassAdded, {}, "", isReset).subscribe((data) => {
        if (data.status === 200) {
            if (data.body.data !== null && data.body.data !== undefined && data.body.data.length > 0) {
          }
        }
      }, error => {
      })
    }
    else {
      this.isResponseScroll = false;
      chatdata.LikeClassAdded = true;
      chatdata.disLikeClassAdded = false;
      chatdata.SubmitFeedback = false;
      let isReset = this.VerifyIsReset(chatdata.LikeClassAdded, chatdata.disLikeClassAdded);
      this.chatbotService.UpdateDisLikeFeedback(ChatHistoryID, chatdata.LikeClassAdded, {}, "", isReset).subscribe((data) => {
        if (data.status === 200) {
            if (data.body.data !== null && data.body.data !== undefined && data.body.data.length > 0) {
            }
        }
      }, error => {
        this.loggerService.logError(this.ChatbotOldComponentError(error), "LikeDisLike")
      })
    }
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "LikeDisLike")
    return;
  }
  }

  /* istanbul ignore next */
  RegenerateActions(question: any, promptAction: any) {
    this.updateQuestion = question;
    this.prompt = promptAction;
    this.SendRequest(true);
  }

  handleCheckboxChange(item1: any) {
    if (item1.isChecked) {
      this.sessionIdClickArray.push(item1.sessionid);
    }
    else {
      const index: number = this.sessionIdClickArray.indexOf(item1.sessionid);
      if (index !== -1) {
        this.sessionIdClickArray.splice(index, 1);
      }
    }


  }
  ExportSession() {
    this.GetChatHistory(this.sessionIdClickArray);
    this.showLoader();
    this.data = {
      UserId: this.UserID,
      SessionId: this.sessionIdClickArray,
      DomainId: this.DomainID,
      tenantID: this.tenantID
    }

    this.chatbotService.GetChatHistoryAPI(this.data)
      .subscribe({
        next: (data) => {
          this.hideLoader();
          if (data.status === "200") {
            if (data.response !== null && data.response !== undefined) {
              if (data.response.data !== null && data.response.data !== undefined && data.response.data.length > 0) {
                const headers = ['ChatTitle', 'Question', 'Response', 'PromtType', 'Source']; // Headers for your Excel file
                const fileName = 'exported_data';
                let exportlistObj: [] = data.response.data.map((item: { chatname: any; question: any; answer: any, longtext: any, regeneratetext: any, shottext: any, source: any }) => {
                  let promtType = "Default";
                  if (item.longtext) {
                    promtType = "Longer";
                  } else if (item.regeneratetext) {
                    promtType = "Regenerated";
                  } else if (item.shottext) {
                    promtType = "Shorter";
                  }
                  return {
                    ChatTitle: item.chatname,
                    Question: item.question,
                    Response: item.answer,
                    PromtType: promtType,
                    Source: "IMPACT"
                  };
                });
                const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportlistObj, {
                  header: headers,
                });
                // Add styles to header cells (change cell styles as needed)
                const headerCellStyle = {
                  fill: {
                    fgColor: { rgb: 'FFD700' }, // Yellow background color
                  },
                  font: { bold: true }, // Bold font
                };
                /* istanbul ignore next */
                if (ws['!ref']) {
                  const headerRange = XLSX.utils.decode_range(ws['!ref']);
                  for (let colIndex = headerRange.s.c; colIndex <= headerRange.e.c; colIndex++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: headerRange.s.r, c: colIndex });
                    ws[cellAddress].s = headerCellStyle;
                  }
                }
                const wb: XLSX.WorkBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
                XLSX.writeFile(wb, fileName + '.xlsx');
              }
            }
          }
        },
        error: (e) => { this.hideLoader(); }
      });


  }

  /* istanbul ignore next */
  PopularQuestionClick(question: string) {
    this.txtChat = question;
    this.prompt = 'default';
    this.SendRequest(false);
    setTimeout(() => {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.adjustHeight();
      }
    });
  }

  getInsightViewURL(encryptInsightId: string) {

    let domainURL = this.configdata.DomainURL;

    const newTab = window.open(domainURL + this.InsightViewURL + encryptInsightId, '_blank');

    newTab?.focus();
  }

  // This method generates a URL for viewing a specific insight based on its ID.
  getInsightViewURLForHref(ins_id: string) {
    // Retrieve the base URL for the application's frontend from the configuration data.
    // This URL is where the insight view page is hosted.
    let domainURL = this.configdata.FusionAppUIUrl; // Alternative URL previously used: this.configdata.RIUIUrl;

    // Construct the full URL for the insight view.
    // The insight ID is first URL-encoded to ensure it can be safely included as part of a URL,
    // and then it is base64-encoded to match the expected format or for additional obfuscation.
    // The encoded insight ID is appended to the base URL and a predefined path for the insight view page.
    return domainURL + this.InsightViewURL + window.btoa(encodeURIComponent(ins_id));
  }


  isMetadataNotEmpty(metadata: any): boolean {
    if (!Array.isArray(metadata) || metadata.length === 0) {
      return false;
    }
    return JSON.stringify(metadata[0]) !== '{}'
  }


  clearCheckboxes(chatdata: any) {

    this.isResponseScroll = false;
    if (chatdata.FeedbackOptions) {
      // Reset all IsChecked properties to false
      chatdata.FeedbackOptions.forEach((option: any) => {
        option.IsChecked = false;
      });
    }
    if (chatdata) {
      chatdata.AdditionalComments = "";
    }
    chatdata.disLikeClassAdded = false;
    chatdata.SubmitFeedback = false;
    chatdata.ErrorMsg = false;
  }
  Dislikesubmit(chatdata: any, ChatHistoryID: number, Dislike: boolean) {
    try{
    this.FeedbackCBDict = {};
    this.isResponseScroll = false;
    let count = 0;
    if (chatdata.FeedbackOptions) {
      chatdata.FeedbackOptions.forEach((FB: any, ind: any) => {
        if (FB.IsChecked) {
          count++;
        }
      });
    }
    if (count > 0) {
      chatdata.FeedbackOptions.forEach((subcat: any, ind: any) => {
        if (subcat.IsChecked) {
          this.FeedbackCBDict[subcat.Id] = subcat.Name;
        }
      });
      const jsonData = JSON.stringify(this.FeedbackCBDict);
      this.isResponseScroll = false;
      const comments = chatdata.AdditionalComments.length > 0 ? chatdata.AdditionalComments : " ";
      let isReset = this.VerifyIsReset(chatdata.LikeClassAdded, chatdata.disLikeClassAdded);

      this.chatbotService.UpdateDisLikeFeedback(ChatHistoryID, Dislike, jsonData, comments, isReset).subscribe((data: any) => {

        if (data.status === "200") {
          if (data.body.data !== null && data.body.data !== undefined && data.body.data.length > 0) {
          }
        }
      }, error => {
      })
      chatdata.SubmitFeedback = false;
    }
    else {
      chatdata.ErrorMsg = true;
    }
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "Dislikesubmit")
    return;
  }
  }
  DisLikeclick(chatdata: any, ChatHistoryID: number, DisLike: boolean) {
    try{
    this.isResponseScroll = false;
    if (this.configdata && Array.isArray(this.configdata.FeedbackOptions)) {
      chatdata.FeedbackOptions = this.configdata.FeedbackOptions.map((option: any) => ({
        ...option,
        pk_chathistoryid: chatdata.pk_chathistoryid
      }));
    } else {
      chatdata.FeedbackOptions = [];
    }
    if (!chatdata.disLikeClassAdded) {
      chatdata.AdditionalComments = "";
      chatdata.disLikeClassAdded = true;
      chatdata.SubmitFeedback = true;
      chatdata.LikeClassAdded = false;
      chatdata.ErrorMsg = false;
    }
    else {
      chatdata.disLikeClassAdded = false;
      chatdata.SubmitFeedback = false;
      this.clearCheckboxes(chatdata);
      chatdata.AdditionalComments = "";
      let isReset = this.VerifyIsReset(chatdata.LikeClassAdded, chatdata.disLikeClassAdded);
      this.chatbotService.UpdateDisLikeFeedback(ChatHistoryID, DisLike, {}, "", isReset).subscribe((data) => {
        if (data.status === 200) {
          if (data.body.data !== null && data.body.data !== undefined && data.body.data.length > 0) {
          }
        }
      }, error => {
        this.loggerService.logError(this.ChatbotOldComponentError(error), "DisLikeclick")
      })
    }
  }
  catch(error: any){
    this.loggerService.logError(this.ChatbotOldComponentError(error), "DisLikeclick")
    return;
  }
  }
  VerifyIsReset(islike: any, isdislike: any) {
    if (!islike && !isdislike) {
      return true;
    }
    return false;
  }
  DisplayChatHistory() {
    this.ShowChatHistory = !this.ShowChatHistory;
  }

  DisableChatHistory() {
    this.ShowChatHistory = false;
  }

  isChatSessionListValid(): boolean {
    return this.chatSessionList.filter((item: any) => item.chat_name !== 'New Topic').length > 0;
  }

  getConversationHistoryCount(): number {
    const count = this.chatSessionList.filter((item: any) => item.chat_name !== 'New Topic').length;
    return count;
  }

  displayCountries(countries: string[]): { firstTwo: string, remainingCount: number } {
    const countryArray = countries.map(country => country.trim());
    const firstTwo = countryArray.slice(0, 2).join(', ');
    const remainingCount = countryArray.length - 2;
    return { firstTwo, remainingCount };
  }

  ShowRegulationMarkets(countries: any, ins_id: string, title: string) {
    this.isResponseScroll = false;
    this.ShowRegulationMarketsWindow = true;
    this.RegulationId = ins_id;
    this.RegulationMarkets = countries.join(', ');
    this.RegulationTitle = title;
  }

  CancelShowRegulationMarketsWindow() {
    this.isResponseScroll = false;
    this.ShowRegulationMarketsWindow = false;
    this.RegulationId = "";
    this.RegulationMarkets = "";
    this.RegulationTitle = "";
  }

  handleCancel(): void {
    this.isResponseScroll = false;
    this.ShowRegulationMarketsWindow = false;
    this.RegulationId = "";
    this.RegulationMarkets = "";
    this.RegulationTitle = "";
  }

  CloseSuccessMessage() {
    this.isResponseScroll = false;
    this.DeleteSuccessMessage = false;
    this.EditSuccessMessage = false;
    this.IsCustomErrorMessageVisible = false;
    this.CustomErrorMessageText = "";
  }

  onEnterPress(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault(); // Prevents a new line
  
    if (this.isProcessing) return; // Ignore if already processing
  
    this.isProcessing = true; // Set flag to prevent multiple calls
    this.SendRequest(false);
  
    setTimeout(() => {
      this.isProcessing = false;
      // Defensive array validation in async callback
      if (!Array.isArray(this.ChatQueriesList)) this.ChatQueriesList = [];
      if (!Array.isArray(this.chatSessionList)) this.chatSessionList = [];
      if (!Array.isArray(this.followUpQuestions)) this.followUpQuestions = [];
    }, 1000);
  }  
}